import Vue from "vue";
import axios from "axios";
import Store from "@/store/index.js";
import VueRouter from "vue-router";
import Login from "@/views/Login.vue";
import PasswordRecovery from "@/views/PasswordRecovery.vue";
import EnvioSmsDesbloqueo from "@/views/EnvioSmsDesbloqueo.vue";
import Main from "@/views/Main.vue";
import Index from "@/components/pages/main/Index.vue";
import MetodosGenrales from "@/utils/metodosgenerales.vue.js";

/* Favoritos */
import Favorito from "@/components/pages/operacion/MisPendientes/favorito/Inicio.vue";

/* Blog */
import BlogPost from "@/components/pages/main/blog/blogDetail.vue";
import BlogAdminPost from "@/components/pages/BlogAdmin/BlogAdminDetail.vue";

/* Blog Admin */
import BlogAdmin from "@/components/pages/BlogAdmin/BlogAdmin.vue";

/* Documentacion */
import Doc from "@/components/pages/documentos/list.vue";
import DocView from "@/components/pages/GestoriaDoc/documentos.vue";
import DocCalif from "@/components/pages/GestoriaDoc/calificarDoc.vue";

/* ERROR */
import NotAuthorized from "@/views/error/NotAuthorized.vue";
import PageNotFound from "@/views/error/PageNotFound.vue";
import NoAutorizado from "@/views/error/SinAutorizacion.vue";

/* Operacion */
import Operacion from "@/components/pages/operacion/Operacion.vue";
import Tablero from "@/components/pages/operacion/tablero/Main.vue";
import TableroGD from "@/components/pages/operacion/tableroGD/Main.vue";
import DashBoard from "@/components/pages/operacion/tableroDB/DashboardGerente.vue";
import TableroDB from "@/components/pages/operacion/tableroDB/Main.vue";

/* Carga Layout*/
import CargaLayout from "@/components/pages/GestoriaDoc/CargaLayout.vue";

/*Control de Citas*/
import Citas from "@/components/pages/ControldeCitas/HistorialCitas.vue";
/*Busqueda */
import busquedaAvanzada from "@/components/pages/busqueda/BusquedaAvanzada.vue";
import busquedageneral from "@/components/pages/busqueda/BusquedaGeneral.vue";
import DatosIncompletos from "@/components/pages/busqueda/DatosIncompletos.vue";

/* Gestoria Documental */
import IndexGD from "@/components/pages/GestoriaDoc/indexGD.vue";
import ReporteGD from "@/components/pages/GestoriaDoc/Reporte.vue";
import ReporteDetalleGD from "@/components/pages/GestoriaDoc/Detalle.vue";
import Movimientos from "@/components/pages/GestoriaDoc/Seguimientos.vue";
import Seguimiento from "@/components/pages/GestoriaDoc/Seguimiento.vue";
import SeguimientoAgregarMovimiento from "@/components/pages/GestoriaDoc/SeguimientoAgregarMovimiento.vue";
import Tramites from "@/components/pages/GestoriaDoc/Tramite.vue";
import ValidacionAgregarMovimiento from "@/components/pages/GestoriaDoc/ValidacionAgregarMovimiento.vue";

import Archivos from "@/components/pages/Archivos/Main.vue";
import EnviarCorreo from "@/components/pages/Archivos/EnviarCorreo.vue";
import CalificarDocs from "@/components/pages/Archivos/CalificarDocumento.vue";
import DocumentoNoConformes from "@/components/pages/Archivos/DocumentosNoConformes.vue";
import AdjuntarDocumento from "@/components/pages/Archivos/AdjuntarDocumentoManual.vue";
import AdjuntarCorreo from "@/components/pages/Archivos/AdjuntarCorreo.vue";
import AdjuntarLlamada from "@/components/pages/Archivos/AdjuntarLlamada.vue";
import AdjuntarVideo from "@/components/pages/Archivos/AdjuntarVideo.vue";
import ExportarPDF from "@/components/pages/Archivos/PDF.vue";
import Reclasificacion from "@/components/pages/Archivos/Reclasificacion.vue";
import DividirPDF from "@/components/pages/Archivos/DividirPDF.vue";
import EnlaceLlamada from "@/components/pages/Archivos/EnlaceLlamada.vue";

import Demeritos from "@/components/pages/GestoriaDoc/Demeritos.vue";
import DoctosAusa from "@/components/pages/GestoriaDoc/ValidacionDoctosAusa.vue";

import MainPendientes from "@/components/pages/GestoriaDoc/MisPendientes/Main.vue";
import doctoAdjuntar from "@/components/pages/GestoriaDoc/MisPendientes/doctoAdjuntar.vue";
import doctoAdjunto from "@/components/pages/GestoriaDoc/MisPendientes/doctoAdjunto.vue";
import ContactoRespuesta from "@/components/pages/GestoriaDoc/MisPendientes/PrimerContactoResNo.vue";

/****Tramite Pago****/
//import ReporteAbogado from "@/components/pages/General/Reporte.vue";
//import DetalleAbogado from "@/components/pages/General/DetalleReporte.vue";
import Honorario from "@/components/pages/PagoProveedor/TramitePago/Honorario.vue";
import Inicio from "@/components/pages/PagoProveedor/Main.vue";
import ReportesAbogado from "@/components/pages/PagoProveedor/TramitePago/ReportesAbogado.vue";
import EnvioTramite from "@/components/pages/PagoProveedor/TramitePago/EnvioSolicitudPago.vue";
import DoctoPendiente from "@/components/pages/PagoProveedor/ProcesarPago/DoctoPendiente.vue";
import RecepcionDocto from "@/components/pages/PagoProveedor/ProcesarPago/RecepcionDocto.vue";
import ReportesPendientes from "@/components/pages/PagoProveedor/ProcesarPago/ReportesPendientes.vue";
import EnviarDocto from "@/components/pages/PagoProveedor/ProcesarPago/EnvioDocto.vue";
import DoctoTramite from "@/components/pages/PagoProveedor/ProcesarPago/DoctoTramitePendiente.vue";
import RecibirReporte from "@/components/pages/PagoProveedor/ProcesarPago/AceptaDocto.vue";
import DoctoPendienteRecibir from "@/components/pages/PagoProveedor/ProcesarPago/DoctoPendienteRecibir.vue";
import ReportesPendientePagar from "@/components/pages/PagoProveedor/ProcesarPago/ReportesPendientePagar.vue";

import ValidaReporte from "@/components/pages/PagoProveedor/ProcesarPago/ValidacionReportes.vue";
import ProcesoPago from "@/components/pages/PagoProveedor/ProcesarPago/ProcesoPago.vue";
import ReportePendienteValidar from "@/components/pages/PagoProveedor/ProcesarPago/ReportesPendienteValidar.vue";
import SolicitarFactura from "@/components/pages/PagoProveedor/ProcesarPago/SolicitarFactura.vue";
import EnvioSolicitudFactura from "@/components/pages/PagoProveedor/ProcesarPago/EnvioSolicitudFactura.vue";

import EnvioFacturas from "@/components/pages/PagoProveedor/TramitePago/EnvioFacturas.vue";
import AdjuntarFactura from "@/components/pages/PagoProveedor/TramitePago/AdjuntarFactura.vue";
import ListadoContrarecibo from "@/components/pages/PagoProveedor/ProcesarPago/ListadoContrarecibo.vue";
import RealizarPago from "@/components/pages/PagoProveedor/ProcesarPago/RealizarPago.vue";

import CargarRegistros from "@/components/pages/PagoProveedor/GNP/CargarRegistros.vue";

/*Expediente Juridico*/
import ReporteExpJur from "@/components/pages/ExpJur/Reporte.vue";
import DetalleExpJur from "@/components/pages/ExpJur/Detalle.vue";
import Danos from "@/components/pages/ExpJur/Danos.vue";
import Lesiones from "@/components/pages/ExpJur/Lesiones.vue";
import ConclusionDanos from "@/components/pages/ExpJur/ConclusionDanos.vue";
import ConclusionLesiones from "@/components/pages/ExpJur/ConclusionLesionesH.vue";
import VolanteExpJur from "@/components/pages/ExpJur/Volante.vue";
import ListadoNegociaciones from "@/components/pages/ExpJur/Negociaciones/ListadoNegociaciones.vue";
import AltaMovimiento from "@/components/pages/ExpJur/Negociaciones/AltaMovimiento.vue";
import ValidacionNegociacion from "@/components/pages/ExpJur/Negociaciones/ValidacionNegociacion.vue";
import SinNegociacion from "@/components/pages/ExpJur/Negociaciones/SinNegociacion.vue";
import AgregarMovimientosExpJur from "@/components/pages/Shared/Movimientos/AgregarMovimiento.vue";
import Redirect from "@/components/pages/busqueda/Redirect.vue";
import BuscaPre from "@/components/pages/busqueda/BuscaPre.vue";
import Recuperacion from "@/components/pages/ExpJur/Negociaciones/Pago.vue";

import JuiciosOralesExpJur from "@/components/pages/Shared/Movimientos/JuiciosOrales.vue";
import AvePreviaExpJur from "@/components/pages/Shared/Movimientos/AveriguacionPrevia.vue";
import LiberacionVehExpJur from "@/components/pages/Shared/Movimientos/LiberacionVehiculo.vue";
import CivicoExpJur from "@/components/pages/Shared/Movimientos/CivicoCivil.vue";

import Contralorias from "@/components/pages/General/Contraloria.vue";
import Reasignacion from "@/components/pages/General/Reasignacion.vue";
import ReasignacionLider from "@/components/pages/General/ReasignacionLider.vue";
import AcompanaPA from "@/components/pages/General/AcompanamientoPA/Acompanamiento.vue";
/*CIVIl */
import DetalleCivil from "@/components/pages/Civil/Detalle.vue";
import Civil from "@/components/pages/Shared/Movimientos/Civil.vue";
import AgregarMovimientosCivil from "@/components/pages/Shared/Movimientos/AgregarMovimiento.vue";

/*Robo*/
import ReporteRobo from "@/components/pages/Robo/Reporte.vue";
import DetalleRobo from "@/components/pages/Robo/Detalle.vue";
//import AverPrev from "@/components/pages/Robo/AverPrev.vue";

import AvePreviaRobo from "@/components/pages/Shared/Movimientos/AveriguacionPrevia.vue";
import AgregarMovimientosRobo from "@/components/pages/Shared/Movimientos/AgregarMovimiento.vue";
import LiberacionVehRobo from "@/components/pages/Shared/Movimientos/LiberacionVehiculo.vue";

/*RLV*/
import ReporteRLV from "@/components/pages/RLV/Reporte.vue";
import DetalleRLV from "@/components/pages/RLV/Detalle.vue";
import AverPrevRLV from "@/components/pages/Shared/Movimientos/AveriguacionPrevia.vue";
import LiberacionVehRLV from "@/components/pages/Shared/Movimientos/LiberacionVehiculo.vue";
import Judicializacion from "@/components/pages/RLV/Judicializacion.vue";
import AgregarMovimientoRLV from "@/components/pages/RLV/AgregarMovimiento.vue";
import AgregarMovimientosRLV from "@/components/pages/Shared/Movimientos/AgregarMovimiento.vue";

/*RCMedico*/
import ReporteRCMedico from "@/components/pages/RCMedico/Reporte.vue";
import DetalleRCMedico from "@/components/pages/RCMedico/Detalle.vue";
import RCProfesional from "@/components/pages/RCMedico/RCProfesional.vue";

/*Whatsapp */
import Whatsapp from "@/components/pages/Whatsapp/Main.vue";
import Whatsapp_General from "@/components/pages/Whatsapp/Whatsapp.vue";
import MisPendientesWhatsApp from "@/components/pages/Whatsapp/MisPendientes.vue";

/*Movimientos*/
import EditarMovimiento from "@/components/pages/General/Movimientos/EditarMovimiento.vue";

/*Garantias*/
import ImpulsosProcesales from "@/components/pages/General/ImpulsosProcesales/ImpulsosProcesales.vue";
import Garantias from "@/components/pages/General/Garantias/Garantias.vue";
import SolicitarPago from "@/components/pages/General/Garantias/SolicitarPago.vue";
import FormatoSolicitud from "@/components/pages/General/Garantias/FormatoSolicitud.vue";
import PresolicitudPago from "@/components/pages/General/Garantias/PresolicitudPago.vue";
import AutorizarPago from "@/components/pages/General/Garantias/AutorizacionPago.vue";

/*Seguimiento*/
import SeguimientoGeneral from "@/components/pages/General/Seguimiento/Seguimiento.vue";

/*Desconclusion*/
import Desconclusion from "@/components/pages/General/Desconclusion/DesConclusion.vue";
import AutorizarCon from "@/components/pages/General/AutorizarDesconclusion.vue";
import SolicitarCon from "@/components/pages/General/SolicitarDesconclusion.vue";

//Detalle Abogado
import DetalleAbogadoRep from "@/components/pages/Proveedor/DetalleAbogado.vue";

/*Tramites*/
import MovimientoTramite from "@/components/pages/General/Tramites/movimientosTramite.vue";

/* Conclusión */
import AutorizarConclusion from "@/components/pages/General/Conclusion/AutorizarConclusion.vue";
import ConcluirConclusion from "@/components/pages/General/Conclusion/ConcluirConclusion.vue";

/* Estadisticas*/
import Menu from "@/components/pages/operacion/MenuEstadisticas/Inicio.vue";
import EstadistaGeneral from "@/components/pages/operacion/Estadistica/EstadisticaGeneral.vue";
import EstadisticaCivil from "@/components/pages/operacion/Estadistica/Civil.vue";
import Juridico from "@/components/pages/operacion/Estadistica/Juridico.vue";
import EstadisticaRLV from "@/components/pages/operacion/Estadistica/RLV.vue";
import EstadisticaRobo from "@/components/pages/operacion/Estadistica/Robo.vue";
import EstadisticaRCMedico from "@/components/pages/operacion/Estadistica/RCMedico.vue";

/* Mis pendientes*/
import MisPendientesGeneral from "@/components/pages/operacion/MisPendientes/MisPendientesGeneral.vue";
import MisPendientesContacto from "@/components/pages/operacion/MisPendientes/MisPendientesContacto.vue";
import MisPendientesTermino from "@/components/pages/operacion/MisPendientes/MisPendientesTermino.vue";
import MisPendientesVhdetenido from "@/components/pages/operacion/MisPendientes/MisPendientesvhdetenido.vue";
import MisPendientesSolicitudDoc from "@/components/pages/operacion/MisPendientes/MisPendientesSolicitudDoc.vue";
import MisPendientesRecepcionDoc from "@/components/pages/operacion/MisPendientes/MisPendientesRecepcionDoc.vue";
import MisPendientesMontPenGrua from "@/components/pages/operacion/MisPendientes/MisPendientesMontPenGrua.vue";
import MisPendientesPagosPenGrua from "@/components/pages/operacion/MisPendientes/MisPendientesPagosPenGrua.vue";
import MisPendientesConDetenido from "@/components/pages/operacion/MisPendientes/MisPendientesConDetenido.vue";
import MisPendientesPeritajeFav from "@/components/pages/operacion/MisPendientes/MisPendientesPeritajeFav.vue";
import MisPendientesRobo from "@/components/pages/operacion/MisPendientes/MisPendientesRobo.vue";
import MisPendientesRoboSolicitudDoc from "@/components/pages/operacion/MisPendientes/MisPendientesRoboSolicitudDoc.vue";
import MisPendientesRoboRecepcionDoc from "@/components/pages/operacion/MisPendientes/MisPendientesRoboRecepcionDoc.vue";
import MisPendientesPendAutorizar from "@/components/pages/operacion/MisPendientes/MisPendientesPendAutorizar.vue";
import MisPendientesPendSinConcluir from "@/components/pages/operacion/MisPendientes/MisPendientesPendSinConcluir.vue";
import MisPendientesConRechazada from "@/components/pages/operacion/MisPendientes/MisPendientesConcRechazada.vue";
import MisPendientesSinVolante from "@/components/pages/operacion/MisPendientes/MisPendientesSinVolante.vue";
import MisPendientesDiasSinMov from "@/components/pages/operacion/MisPendientes/MisPendientesDiasSinMov.vue";
import MisPendientesAsuntosRelevantes from "@/components/pages/operacion/MisPendientes/MisPendientesAsuntosRelevantes.vue";
import MisPendientesLlamadasCI from "@/components/pages/operacion/MisPendientes/MisPendientesLlamadasCI.vue";
import MisPendientesPendientesCapturar from "@/components/pages/operacion/MisPendientes/MisPendientesPendientesCapturar.vue";
import MisPendientesPendientesAutorizar from "@/components/pages/operacion/MisPendientes/MisPendientesPendientesAutorizar.vue";
import MisPendientesAsistenciaCivil from "@/components/pages/operacion/MisPendientes/MisPendientesAsistenciaCivil.vue";
import MisPendientesDocumentosValidar from "@/components/pages/operacion/MisPendientes/MisPendientesDocumentosValidar.vue";
import MisPendientesDocumentosRechazados from "@/components/pages/operacion/MisPendientes/MisPendientesDocumentosRechazados.vue";
import MisPendientesMovDiaAnterior from "@/components/pages/operacion/MisPendientes/MisPendientesMovDiaAnterior.vue";

/*Utilidades*/
import UtilidadesBitacora from "@/components/pages/operacion/MenuUtilidades/Bitacora.vue";
import UtilidadesConcluidos from "@/components/pages/operacion/MenuUtilidades/Concluidos.vue";
import CitasPendientes from "@/components/pages/operacion/MenuUtilidades/CitasPendientes.vue";
import ReasignacionesMasivas from "@/components/pages/operacion/MenuUtilidades/ReasignacionesMasivas.vue";
import BuscarProveedor from "@/components/pages/operacion/MenuUtilidades/BuscarProveedor.vue";
import ConsultaProductos from "@/components/pages/operacion/MenuUtilidades/ConsultaProductos.vue";

/*WS*/
import SeguimientoGNP from "@/components/pages/operacion/Utilidades/WS/SeguimientoGNP.vue";
import SeguimientoAtlas from "@/components/pages/operacion/Utilidades/WS/SeguimientoAtlas.vue";
import ArchivoGNP from "@/components/pages/operacion/Utilidades/WS/ArchivoGNP.vue";
import ArchivoAtlas from "@/components/pages/operacion/Utilidades/WS/ArchivoAtlas.vue";
import BitacoraAtlas from "@/components/pages/operacion/Utilidades/WS/Bitacora.vue";

/*Poderes*/
import altapoder from "@/components/pages/operacion/Poderes/AltaPoder.vue";
import BusquedaPoderes from "@/components/pages/operacion/Poderes/BusquedaPoder.vue";
import BusquedaEstado from "@/components/pages/operacion/Poderes/BusquedaEstado.vue";
import DetallePoderes from "@/components/pages/operacion/Poderes/DetallesPoder.vue";
import AgregarMovimiento from "@/components/pages/operacion/Poderes/AgregarMovimiento.vue";
import ListadoPendiente from "@/components/pages/operacion/Poderes/ListadoPendiente.vue";

/*Indicadores */
import IndicadorDiario from "@/components/pages/operacion/MenuIndicadores/IndicadorDiario.vue";
import IndicadoresDefinicionDiario from "@/components/pages/operacion/MenuIndicadores/IndicadoresDefinicion.vue";
import IndicadoresDefinicionMensual from "@/components/pages/operacion/MenuIndicadores/IndicadoresDefinicionMensual.vue";
import IndicadorMensual from "@/components/pages/operacion/MenuIndicadores/IndicadorMensual.vue";
import IndicadorSupervisor from "@/components/pages/operacion/MenuIndicadores/IndicadorSupervisor.vue";
import IndicadorAnioAnterior from "@/components/pages/operacion/MenuIndicadores/IndicadorAnioAnterior.vue";

/*Lideres*/
import LideresMain from "@/components/pages/Lideres/LideresMain.vue";
import AgregarMovimientoValider from "@/components/pages/Lideres/AgregarMovimientoValider.vue";
import PantallaAjustador from "@/components/pages/Lideres/PantallaAjustador.vue";
import PantallaNA from "@/components/pages/Lideres/PantallaNA.vue";
import PantallaAB from "@/components/pages/Lideres/PantallaAB.vue";
import ReasignacionLideres from "@/components/pages/Lideres/ReasignacionLideres.vue";
import Notificaciones from "@/components/pages/Lideres/components/Notificaciones.vue";
import CriterioLider from "@/components/pages/Lideres/components/CriterioLider.vue";
import Indicios from "@/components/pages/Lideres/components/Indicios.vue";
import DatosPrueba from "@/components/pages/Lideres/components/DatosPrueba.vue";
import Precierre from "@/components/pages/Lideres/components/Precierre.vue";
/* Finanzas */
import AdminContrarecibo from "@/components/pages/Finanzas/AdminContrarecibo.vue";

/* Fianzas */
import Recuperaciones from "@/components/pages/Contraloria/Recuperaciones/SeguimientoRecuperaciones.vue";
import AltaMovRec from "@/components/pages/Contraloria/Recuperaciones/AltaMovimientoRecuperaciones.vue";
import EstadisticoRec from "@/components/pages/Contraloria/Recuperaciones/EstadisticoRecuperaciones.vue";
import MenuRecup from "@/components/pages/Contraloria/Inicio.vue";
import RecuperacionesPendientes from "@/components/pages/Contraloria/Recuperaciones/RecuperacionesPendientes.vue";
import FinanzasPrincipal from "@/components/pages/Contraloria/Fianzas/FinanzasPrincipal.vue";
import AltaFianzas from "@/components/pages/Contraloria/Fianzas/AltaFianzas.vue";
import DetalleFianza from "@/components/pages/Contraloria/Fianzas/DetalleFianza.vue";
import AsignarFianza from "@/components/pages/Contraloria/Fianzas/AsignarFianza.vue";
import UtilizarFianza from "@/components/pages/Contraloria/Fianzas/UtilizarFianza.vue";
import RecibirFianza from "@/components/pages/Contraloria/Fianzas/RecibirFianza.vue";
import NotificarFianza from "@/components/pages/Contraloria/Fianzas/NotificarFianza.vue";

/* Quejas */
import LevantarQueja from "@/components/pages/Quejas/LevantarQueja.vue";
import QuejasAdministracion from "@/components/pages/Quejas/QuejasAdministracion.vue";
import DetalleQueja from "@/components/pages/Quejas/DetalleQueja.vue";
import QuejasPendientes from "@/components/pages/Quejas/QuejasPendientes.vue";

/* Perfil Usuario*/
import Perfil from "@/components/pages/main/Perfil/PerfilUsuario.vue";
import RestablecerFirma from "@/components/pages/main/Perfil/RestablecerFirma.vue";
import RestablecerContrasenia from "@/components/pages/main/Perfil/RestablecerContrasenia.vue";
/* Quejas */
import Asistencia from "@/components/pages/Asistencia/Asistencia.vue";

/*Calidad*/
import RealizarEncuesta from "@/components/pages/Calidad/RealizarEncuesta.vue";
import EncuestasContestadas from "@/components/pages/Calidad/EncuestasContestadas.vue";
import EstadisticaEncuesta from "@/components/pages/Calidad/EstadisticaEncuesta.vue";
import EstadisticaNPS from "@/components/pages/Calidad/EstadisticaNPS.vue";
import MisPendientesNPS from "@/components/pages/Calidad/MisPendientesNPS.vue";
import CalificarAgentes from "@/components/pages/Calidad/CalificarAgentes.vue";

/*Sistemas*/
import Sistemas from "@/components/pages/Sistemas/MenuSistemas.vue";
import InicioRA from "@/components/pages/Sistemas/main.vue";
import Listado from "@/components/pages/Sistemas/ReporteAutomatico/main.vue";
import ReporteA from "@/components/pages/Sistemas/ReporteAutomatico/ReporteAutomatico.vue";
import Historial from "@/components/pages/Sistemas/ReporteAutomatico/Historial.vue";
import AdministrarNotificacionesBusqueda from "@/components/pages/Sistemas/Notificaciones/Busqueda.vue";
import AltaNotificacion from "@/components/pages/Sistemas/Notificaciones/AltaNotificacion.vue";
import AcortadorBusqueda from "@/components/pages/Sistemas/Acortador/Busqueda.vue";
import DetalleAcortador from "@/components/pages/Sistemas/Acortador/DetalleAcortador.vue";
import AltaAcortador from "@/components/pages/Sistemas/Acortador/AltaAcortador.vue";
import DetalleProceso from "@/components/pages/Sistemas/Notificaciones/DetalleProceso.vue";
import EnviarSms from "@/components/pages/Sistemas/EnviarSMS/EnviarSMS.vue";
import OpenAI from "@/components/pages/Sistemas/OpenAI/OpenAI.vue";
import OpenAIVH from "@/components/pages/Sistemas/OpenAI/OpenAIVH.vue";
import CambioContacto from "@/components/pages/Sistemas/CambiarNumeroCI/cambiar_numero.vue";
import BusquedaUsuarios from "@/components/pages/Sistemas/Administracion/BusquedaUsuarios.vue";
import DetalleUsuario from "@/components/pages/Sistemas/Administracion/DetalleUsuario.vue";
import Formato from "@/components/pages/Sistemas/Administracion/Formato.vue";
import AltaUsuario from "@/components/pages/Sistemas/Administracion/AltaUsuario.vue";
import DetallePreUsuario from "@/components/pages/PreAlta/PreAltaDetalle.vue";
/*Pre Alta */
import Pre_Alta from "@/components/pages/PreAlta/Pre_Alta.vue";
import PreAltasAutorizadas from "@/components/pages/Sistemas/Administracion/Autorizadas.vue";

import MetodosGenerales from "@/utils/metodosgenerales.vue.js";

/*Asistencia General*/
import Asistencias from "@/components/pages/AsistenciaGeneral/Inicio.vue";
import DetalleAsisten from "@/components/pages/AsistenciaGeneral/Detalle.vue";
import MovimientoGeneral from "@/components/pages/Shared/Movimientos/MovimientoGeneral.vue";

/*Vacaciones*/
import Solicitud from "@/components/pages/Vacaciones/SolicitudVacaciones.vue";
import Autorizar from "@/components/pages/Vacaciones/AutorizarVacaciones.vue";

/*Notas*/
import Notas from "@/components/pages/General/Notas/Notas.vue";

/*Carga masiva civil */
import CargaMCivil from "@/components/pages/Civil/CargaMasiva.vue";

Vue.use(VueRouter);
const domain = Store.state.domain;
const permisos = Store.state.permission;
const informationPage = Store.state.informationPage;

const getCookie = (name) => {
  const cookies = document.cookie.split(";");
  for (let i = 0; i < cookies.length; i++) {
    let c = cookies[i].trim().split("=");
    if (c[0] === name) {
      return decodeURIComponent(c[1]);
    }
  }
  return "";
};

function verficarPermiso(to, from, next, permiso, nrreporte, svindice) {
  MetodosGenrales.verificarPermisoSolo(
    domain.domainNameForApi,
    "VerificarPermiso",
    permiso
  ).then((response) => {
    if (response.data.length > 0) {
      //registrar pagina visitada
      next();
      var url = window.location.origin + window.location.pathname;
      MetodosGenrales.registrarPaginaVisitada(
        to,
        from,
        url,
        domain.domainNameForApi,
        nrreporte,
        svindice
      );
    } else {
      if (permiso == permisos.global) next({ name: "noautorizado" });
      else next({ name: "NoAutorizado" });
    }
  });
}

const routes = [
  {
    path: `${domain.domainName}/login`,
    name: "login",
    component: Login,
    meta: { title: "Prusia+" },
  },
  {
    path: `${domain.domainName}/PasswordRecovery`,
    name: "PasswordRecovery",
    component: PasswordRecovery,
    meta: { title: "PasswordRecovery - Prusia+" },
  },
  {
    path: `${domain.domainName}/EnvioSmsDesbloqueo`,
    name: "EnvioSmsDesbloqueo",
    component: EnvioSmsDesbloqueo,
    meta: { title: "EnvioSmsDesbloqueo - Prusia+" },
  },
  {
    path: `${domain.domainName}/`,
    component: Main,
    //beforeEnter: (to, from, next) => {
    //  verficarPermiso("main", "main", next, permisos.global);
    //},
    redirect: `${domain.domainName}/index`,
    children: [
      {
        path: `index`,
        name: "index",
        component: Index,
        meta: { title: "Inicio - Prusia+" },
        beforeEnter: (to, from, next) => {
          verficarPermiso("index", "index", next, permisos.global);
        },
      },
      {
        path: `Redirect/:tokenData`,
        name: "Redirect",
        component: Redirect,
        meta: { title: "Redirect - Prusia+" },
        props: true,
      },
      {
        path: `BuscaPre/:tokenData`,
        name: "BuscaPre",
        component: BuscaPre,
        props: true,
      },
      {
        path: `noautorizado`,
        name: "NoAutorizado",
        component: NoAutorizado,
        meta: { title: "NoAutorizado - Prusia+" },
      },
      {
        path: `BlogPost/:tokenData`,
        name: "BlogPost",
        component: BlogPost,
        meta: { title: "BlogPost - Prusia+" },
        props: true,
      },
      {
        path: `BlogPostAdmin`,
        name: "BlogAdminPost",
        component: BlogAdminPost,
        meta: { title: "BlogPostAdmin - Prusia+" },
        props: true,
      },
      {
        path: `${domain.domainName}/Blogs`,
        name: "BlogAdmin",
        component: BlogAdmin,
        meta: { title: "Blogs - Prusia+" },
        props: true,
        beforeEnter: (to, from, next) => {
          verficarPermiso(
            "Blogs",
            "Blogs-Administrador",
            next,
            permisos.global
          );
        },
      },
      {
        path: `${domain.domainName}/operacion`,
        name: "operacion",
        component: Operacion,
        children: [
          {
            path: `${domain.domainName}/operacion/dashboard`,
            name: "Dashboard",
            component: DashBoard,
            meta: { title: "Dashboard - Prusia+" },
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "Operacion",
                "Operacion-Dashboard",
                next,
                permisos.single.gerente
              );
            },
          },
          {
            path: `${domain.domainName}/operacion/tablero`,
            name: "tablero",
            component: Tablero,
            meta: { title: "Tablero - Prusia+" },
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "Operacion",
                "Operacion-Tablero",
                next,
                permisos.single.tablero
              );
            },
          },
          {
            path: `${domain.domainName}/operacion/ExpedienteJuridico`,
            name: "Menu",
            component: Menu,
            meta: { title: "ExpedienteJuridico - Prusia+" },
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "Operacion",
                "Operacion-ExpedienteJuridico",
                next,
                permisos.single.expjuridicos
              );
            },
          },
          {
            path: `${domain.domainName}/MisPendientesGral`,
            name: "MisPendientesGeneral",
            component: MisPendientesGeneral,
            meta: { title: "General - Prusia+" },
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "MisPendientes",
                "MisPendientes-General",
                next,
                permisos.global
              );
            },
          },
          {
            path: `${domain.domainName}/MisPendientesDocVal`,
            name: "MisPendientesDocumentosValidar",
            component: MisPendientesDocumentosValidar,
            meta: { title: "Documentos por Validar - Prusia+" },
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "MisPendientes",
                "MisPendientes-General",
                next,
                permisos.global
              );
            },
          },
          {
            path: `${domain.domainName}/MisPendientesDocRechazados`,
            name: "MisPendientesDocumentosRechazados",
            component: MisPendientesDocumentosRechazados,
            meta: { title: "Documentos Rechazados - Prusia+" },
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "MisPendientes",
                "MisPendientes-DocumentosRechazados",
                next,
                permisos.global
              );
            },
          },
          {
            path: `${domain.domainName}/MisPendientesContacto`,
            name: "MisPendientesContacto",
            component: MisPendientesContacto,
            meta: { title: "Contacto - Prusia+" },
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "MisPendientes",
                "MisPendientes-Contacto",
                next,
                permisos.global
              );
            },
          },
          {
            path: `${domain.domainName}/MisPendientesAsistenciaCivil`,
            name: "MisPendientesAsistenciaCivil",
            component: MisPendientesAsistenciaCivil,
            meta: { title: "Asistencia Civil - Prusia+" },
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "MisPendientes",
                "MisPendientes-AsistenciaCivil",
                next,
                367
              );
            },
          },
          {
            path: `${domain.domainName}/MisPendientesTermino`,
            name: "MisPendientesTermino",
            component: MisPendientesTermino,
            meta: { title: "Termino - Prusia+" },
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "MisPendientes",
                "MisPendientes-Termino",
                next,
                permisos.global
              );
            },
          },

          {
            path: `${domain.domainName}/MisPendientesVhdetenido`,
            name: "MisPendientesVhdetenido",
            component: MisPendientesVhdetenido,
            meta: { title: "Vh detenido - Prusia+" },
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "MisPendientes",
                "MisPendientes-VehiculoDetenido",
                next,
                permisos.global
              );
            },
          },
          {
            path: `${domain.domainName}/MisPendientesSolicitudDoc`,
            name: "MisPendientesSolicitudDoc",
            component: MisPendientesSolicitudDoc,
            meta: { title: "Solicitud de Documentación - Prusia+" },
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "MisPendientes",
                "MisPendientes-SolicitudDocumentacion",
                next,
                permisos.global
              );
            },
          },
          {
            path: `${domain.domainName}/MisPendientesRecepcionDoc`,
            name: "MisPendientesRecepcionDoc",
            component: MisPendientesRecepcionDoc,
            meta: { title: "Recepción de Documentación - Prusia+" },
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "MisPendientes",
                "MisPendientes-RecepcionDocumentacion",
                next,
                permisos.global
              );
            },
          },
          {
            path: `${domain.domainName}/MisPendientesMontPenGrua`,
            name: "MisPendientesMontPenGrua",
            component: MisPendientesMontPenGrua,
            meta: { title: "Montos Pensión Multas Grua - Prusia+" },
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "MisPendientes",
                "MisPendientes-MontosPendientesGrua",
                next,
                permisos.global
              );
            },
          },
          {
            path: `${domain.domainName}/MisPendientesPagosPenGrua`,
            name: "MisPendientesPagosPenGrua",
            component: MisPendientesPagosPenGrua,
            meta: { title: "Pagos Pensión Multas Grua - Prusia+" },
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "MisPendientes",
                "MisPendientes-PagosPendientesGrua",
                next,
                permisos.global
              );
            },
          },
          {
            path: `${domain.domainName}/MisPendientesConDetenido`,
            name: "MisPendientesConDetenido",
            component: MisPendientesConDetenido,
            meta: { title: "Conductor Detenido - Prusia+" },
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "MisPendientes",
                "MisPendientes-ConductorDetenido",
                next,
                permisos.global
              );
            },
          },
          {
            path: `${domain.domainName}/MisPendientesPeritajeFav`,
            name: "MisPendientesPeritajeFav",
            component: MisPendientesPeritajeFav,
            meta: { title: "Peritaje Favorable - Prusia+" },
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "MisPendientes",
                "MisPendientes-PeritajeFavorable",
                next,
                permisos.global
              );
            },
          },
          {
            path: `${domain.domainName}/MisPendientesRobo`,
            name: "MisPendientesRobo",
            component: MisPendientesRobo,
            meta: { title: "Robo - Prusia+" },
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "MisPendientes",
                "MisPendientes-Robo",
                next,
                permisos.global
              );
            },
          },
          {
            path: `${domain.domainName}/MisPendientesRoboSolicitudDoc`,
            name: "MisPendientesRoboSolicitudDoc",
            component: MisPendientesRoboSolicitudDoc,
            meta: { title: "Solicitud de Documentación - Prusia+" },
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "MisPendientes",
                "MisPendientes-RoboSolicitudDocumentacion",
                next,
                permisos.global
              );
            },
          },
          {
            path: `${domain.domainName}/MisPendientesRoboRecepcionDoc`,
            name: "MisPendientesRoboRecepcionDoc",
            component: MisPendientesRoboRecepcionDoc,
            meta: { title: "Recepción de Documentación - Prusia+" },
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "MisPendientes",
                "MisPendientes-RoboRecepcionDocumentacion",
                next,
                permisos.global
              );
            },
          },
          {
            path: `${domain.domainName}/MisPendientesPendAutorizar`,
            name: "MisPendientesPendAutorizar",
            component: MisPendientesPendAutorizar,
            meta: { title: "Pendientes de Autorizar - Prusia+" },
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "MisPendientes",
                "MisPendientes-PendientesAutorizar",
                next,
                permisos.global
              );
            },
          },
          {
            path: `${domain.domainName}/MisPendientesPendSinConcluir`,
            name: "MisPendientesPendSinConcluir",
            component: MisPendientesPendSinConcluir,
            meta: { title: "Autorizadas sin Concluir - Prusia+" },
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "MisPendientes",
                "MisPendientes-PendientesSinConcluir",
                next,
                permisos.global
              );
            },
          },
          {
            path: `${domain.domainName}/MisPendientesConRechazada`,
            name: "MisPendientesConRechazada",
            component: MisPendientesConRechazada,
            meta: { title: "Conclusión Rechazada - Prusia+" },
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "MisPendientes",
                "MisPendientes-ConclusionRechazada",
                next,
                permisos.global
              );
            },
          },
          {
            path: `${domain.domainName}/MisPendientesSinVolante`,
            name: "MisPendientesSinVolante",
            component: MisPendientesSinVolante,
            meta: { title: "Sin Volante Jurídico - Prusia+" },
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "MisPendientes",
                "MisPendientes-SinVolanteJuridico",
                next,
                permisos.global
              );
            },
          },
          {
            path: `${domain.domainName}/MisPendientesDiasSinMov`,
            name: "MisPendientesDiasSinMov",
            component: MisPendientesDiasSinMov,
            meta: { title: "Dias Sin Movimiento - Prusia+" },
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "MisPendientes",
                "MisPendientes-DiasSinMovimiento",
                next,
                permisos.global
              );
            },
          },
          {
            path: `${domain.domainName}/MisPendientesLlamadasCI`,
            name: "MisPendientesLlamadasCI",
            component: MisPendientesLlamadasCI,
            meta: { title: "Llamadas por CI - Prusia+" },
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "MisPendientes",
                "MisPendientes-LlamadasCI",
                next,
                permisos.global
              );
            },
          },

          {
            path: `${domain.domainName}/MisPendientesAsuntosRelevantes`,
            name: "MisPendientesAsuntosRelevantes",
            component: MisPendientesAsuntosRelevantes,
            meta: { title: "Asuntos Relevantes - Prusia+" },
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "MisPendientes",
                "MisPendientes-AsuntosRelevantes",
                next,
                permisos.global
              );
            },
          },
          {
            path: `${domain.domainName}/MisPendientesPendientesCapturar`,
            name: "MisPendientesPendientesCapturar",
            component: MisPendientesPendientesCapturar,
            meta: { title: "Pendientes de Capturar - Prusia+" },
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "MisPendientes",
                "MisPendientes-PendientesCapturar",
                next,
                permisos.global
              );
            },
          },
          {
            path: `${domain.domainName}/MisPendientesPendientesAutorizar`,
            name: "MisPendientesPendientesAutorizar",
            component: MisPendientesPendientesAutorizar,
            meta: { title: "Pendientes de Autorizar - Prusia+" },
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "MisPendientes",
                "MisPendientes-PendientesAutorizar",
                next,
                permisos.global
              );
            },
          },
          {
            path: `${domain.domainName}/MisPendientesMovDiaAnterior`,
            name: "MisPendientesMovDiaAnterior",
            component: MisPendientesMovDiaAnterior,
            meta: { title: "Movimientos Día Anterior - Prusia+" },
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "MisPendientes",
                "MisPendientes-MovDiaAnterior",
                next,
                permisos.global
              );
            },
          },
          {
            path: `${domain.domainName}/Proveedor/Buscar`,
            name: "BuscarProveedor",
            component: BuscarProveedor,
            meta: { title: "Buscar Proveedor - Prusia+" },
            beforeEnter: (to, from, next) => {
              verficarPermiso("Proveedor", "PR-Buscar", next, permisos.global);
            },
          },
          {
            path: `${domain.domainName}/Utilidades/ConsultaProductos`,
            name: "ConsultaProductos",
            component: ConsultaProductos,
            meta: { title: "Consulta Productos - Prusia+" },
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "Utilidades",
                "Utils-ConsultaProductos",
                next,
                permisos.global
              );
            },
          },

          {
            path: `${domain.domainName}/Utilidades/BitacoraExpedientes`,
            name: "UtilidadesBitacora",
            component: UtilidadesBitacora,
            meta: { title: "Bitacora Expedientes - Prusia+" },
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "Utilidades",
                "Utilidades-BitacoraExpedientes",
                next,
                permisos.global
              );
            },
          },
          {
            path: `${domain.domainName}/Utilidades/Concluidos`,
            name: "UtilidadesConcluidos",
            component: UtilidadesConcluidos,
            meta: { title: "Concluidos - Prusia+" },
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "Utilidades",
                "Utilidades-Concluidos",
                next,
                permisos.global
              );
            },
          },
          {
            path: `${domain.domainName}/Utilidades/CitasPendientes`,
            name: "CitasPendientes",
            component: CitasPendientes,
            meta: { title: "Citas Pendientes - Prusia+" },
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "Utilidades",
                "Utilidades-CitasPendientes",
                next,
                permisos.global
              );
            },
          },
          {
            path: `${domain.domainName}/Utilidades/ReasignacionesMasivas`,
            name: "ReasignacionesMasivas",
            component: ReasignacionesMasivas,
            meta: { title: "Reasignaciones Masivas - Prusia+" },
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "Utilidades",
                "Utilidades-ReasignacionesMasivas",
                next,
                permisos.global
              );
            },
          },
          {
            path: `${domain.domainName}/Utilidades/WS/SeguimientoGNP`,
            name: "SeguimientoGNP",
            component: SeguimientoGNP,
            meta: { title: "Seguimiento GNP - Prusia+" },
            props: true,
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "Utilidades",
                "Utilidades-WS-SeguimientoGNP",
                next,
                permisos.global
              );
            },
          },
          {
            path: `${domain.domainName}/Utilidades/WS/ArchivoGNP`,
            name: "ArchivoGNP",
            component: ArchivoGNP,
            meta: { title: "Archivo GNP - Prusia+" },
            props: true,
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "Utilidades",
                "Utilidades-WS-ArchivoGNP",
                next,
                permisos.global
              );
            },
          },
          {
            path: `${domain.domainName}/Utilidades/WS/SeguimientoAtlas`,
            name: "SeguimientoAtlas",
            component: SeguimientoAtlas,
            meta: { title: "Seguimiento Atlas - Prusia+" },
            props: true,
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "Utilidades",
                "Utilidades-WS-SeguimientoAtlas",
                next,
                permisos.global
              );
            },
          },
          {
            path: `${domain.domainName}/Utilidades/WS/BitacoraAtlas`,
            name: "BitacoraAtlas",
            component: BitacoraAtlas,
            meta: { title: "Bitacora Atlas - Prusia+" },
            props: true,
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "Utilidades",
                "Utilidades-WS-BitacoraAtlas",
                next,
                permisos.global
              );
            },
          },
          {
            path: `${domain.domainName}/Utilidades/WS/ArchivoAtlas`,
            name: "ArchivoAtlas",
            component: ArchivoAtlas,
            meta: { title: "Archivo Atlas - Prusia+" },
            props: true,
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "Utilidades",
                "Utilidades-WS-ArchivoAtlas",
                next,
                permisos.global
              );
            },
          },
          {
            path: `${domain.domainName}/Estadistica/EstadisticaGeneral`,
            name: "EstadistaGeneral",
            component: EstadistaGeneral,
            meta: { title: "Estadistica General - Prusia+" },
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "Estadistica",
                "Estadistica-EstadisticaGeneral",
                next,
                permisos.global
              );
            },
          },
          {
            path: `${domain.domainName}/Estadistica/Juridico`,
            name: "Juridico",
            component: Juridico,
            meta: { title: "Juridico- Prusia+" },
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "Estadistica",
                "Estadistica-Juridico",
                next,
                permisos.global
              );
            },
          },
          {
            path: `${domain.domainName}/Estadistica/Robo`,
            name: "EstadisticaRobo",
            component: EstadisticaRobo,
            meta: { title: "Robo - Prusia+" },
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "Estadistica",
                "Estadistica-Robo",
                next,
                permisos.global
              );
            },
          },
          {
            path: `${domain.domainName}/Estadistica/RLV`,
            name: "EstadisticaRLV",
            component: EstadisticaRLV,
            meta: { title: "RLV - Prusia+" },
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "Estadistica",
                "Estadistica-RLV",
                next,
                permisos.global
              );
            },
          },
          {
            path: `${domain.domainName}/Estadistica/RCMedico`,
            name: "EstadisticaRCMedico",
            component: EstadisticaRCMedico,
            meta: { title: "RCMedico - Prusia+" },
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "Estadistica",
                "Estadistica-RCMedico",
                next,
                permisos.global
              );
            },
          },
          {
            path: `${domain.domainName}/Estadistica/Civil`,
            name: "EstadisticaCivil",
            component: EstadisticaCivil,
            meta: { title: "Civil - Prusia+" },
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "Estadistica",
                "Estadistica-AsistenciaCivil",
                next,
                permisos.global
                // 373
              );
            },
          },
          {
            path: `${domain.domainName}/Poderes/AltaPoderes`,
            name: "altapoder",
            component: altapoder,
            meta: { title: "Alta Poderes - Prusia+" },
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "Poderes",
                "Poderes-AltaPoderes",
                next,
                permisos.global
              );
            },
          },
          {
            path: `${domain.domainName}/Poderes/BusquedaEstado`,
            name: "BusquedaEstado",
            component: BusquedaEstado,
            meta: { title: "Busqueda por Estado - Prusia+" },
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "Poderes",
                "Poderes-BusquedaEstado",
                next,
                permisos.global
              );
            },
          },
          {
            path: `${domain.domainName}/Poderes/BusquedaPoderes`,
            name: "BusquedaPoderes",
            component: BusquedaPoderes,
            meta: { title: "Busqueda de Poderes - Prusia+" },
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "Poderes",
                "Poderes-BusquedaPoderes",
                next,
                permisos.global
              );
            },
          },
          {
            path: `${domain.domainName}/Poderes/DetallePoderes`,
            name: "DetallePoderes",
            component: DetallePoderes,
            meta: { title: "Detalle de Poderes - Prusia+" },
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "Poderes",
                "Poderes-DetallePoderes",
                next,
                permisos.global
              );
            },
          },
          {
            path: `${domain.domainName}/Poderes/AgregarMovimiento`,
            name: "AgregarMovimiento",
            component: AgregarMovimiento,
            meta: { title: "Agregar Movimiento - Prusia+" },
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "Poderes",
                "Poderes-AgregarMovimiento",
                next,
                permisos.global
              );
            },
          },
          {
            path: `${domain.domainName}/Poderes/ListadoPendiente`,
            name: "ListadoPendiente",
            component: ListadoPendiente,
            meta: { title: "Listado Pendiente - Prusia+" },
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "Poderes",
                "Poderes-ListadoPendiente",
                next,
                permisos.global
              );
            },
          },
          {
            path: `${domain.domainName}/MisPendientesTermino`,
            //name: "MisPendientesTermino",
            component: MisPendientesTermino,
            meta: { title: "Termino - Prusia+" },
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "MisPendientes",
                "MisPendientes-Termino",
                next,
                permisos.global
              );
            },
          },
          {
            path: `${domain.domainName}/Indicadores/IndicadorDiario`,
            name: "IndicadorDiario",
            component: IndicadorDiario,
            meta: { title: "Indicador Diario - Prusia+" },
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "Indicadores",
                "Indicadores-IndicadorDiario",
                next,
                permisos.global
              );
            },
          },
          {
            path: `${domain.domainName}/Indicadores/IndicadoresDefinicionDiario`,
            name: "IndicadoresDefinicionDiario",
            component: IndicadoresDefinicionDiario,
            meta: { title: "Indicadores Definición Diario - Prusia+" },
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "Indicadores",
                "Indicadores-IndicadoresDefinicionDiario",
                next,
                permisos.global
              );
            },
          },
          {
            path: `${domain.domainName}/Indicadores/IndicadoresDefinicionMensual`,
            name: "IndicadoresDefinicionMensual",
            component: IndicadoresDefinicionMensual,
            meta: { title: "Indicadores Definición Mensual - Prusia+" },
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "Indicadores",
                "Indicadores-IndicadoresDefinicionMensual",
                next,
                permisos.global
              );
            },
          },
          {
            path: `${domain.domainName}/Indicadores/IndicadorMensual`,
            name: "IndicadorMensual",
            component: IndicadorMensual,
            meta: { title: "Indicador Mensual - Prusia+" },
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "Indicadores",
                "Indicadores-IndicadorMensual",
                next,
                permisos.global
              );
            },
          },
          {
            path: `${domain.domainName}/Indicadores/IndicadorSupervisor`,
            name: "IndicadorSupervisor",
            component: IndicadorSupervisor,
            meta: { title: "Indicador Supervisor - Prusia+" },
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "Indicadores",
                "Indicadores-IndicadorSupervisor",
                next,
                permisos.global
              );
            },
          },
          {
            path: `${domain.domainName}/Indicadores/IndicadorAnioAnterior`,
            name: "IndicadorAnioAnterior",
            component: IndicadorAnioAnterior,
            meta: { title: "Indicador de Año Anterior - Prusia+" },
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "Indicadores",
                "Indicadores-IndicadorAnioAnterior",
                next,
                permisos.global
              );
            },
          },
        ],
      },
      {
        path: `${domain.domainName}/Contraloria`,
        name: "MenuRecuperaciones",
        component: MenuRecup,
        meta: { title: "Contraloria - Prusia+" },
        children: [
          //{
          //    path: `${domain.domainName}/SeguimientoRecuperaciones`,
          //    name: "SeguimientoRecuperaciones",
          //    component: Recuperaciones,
          //    beforeEnter: (to, from, next) => {
          //        verficarPermiso(
          //            "Recuperaciones",
          //            "Recuperaciones-Seguimiento",
          //            next,
          //            permisos.global
          //        );
          //    },
          //},
          //{
          //    path: `${domain.domainName}/Negociaciones/AltaMovimiento`,
          //    name: "AltaMovimientosRecuperaciones",
          //    component: AltaMovRec,
          //    beforeEnter: (to, from, next) => {
          //        verficarPermiso(
          //            "Recuperaciones",
          //            "Recuperaciones-Alta Movimientos",
          //            next,
          //            permisos.global
          //        );
          //    },
          //},
        ],
      },
      {
        path: `${domain.domainName}/SeguimientoRecuperaciones`,
        name: "SeguimientoRecuperaciones",
        component: Recuperaciones,
        meta: { title: "Seguimiento Recuperaciones - Prusia+" },
        beforeEnter: (to, from, next) => {
          verficarPermiso(
            "Recuperaciones",
            "Recuperaciones-Seguimiento",
            next,
            permisos.global
          );
        },
      },
      {
        path: `${domain.domainName}/Recuperaciones/AltaMovimiento`,
        name: "AltaMovimientosRecuperaciones",
        component: AltaMovRec,
        meta: { title: "Alta Movimiento - Prusia+" },
        props: true,
        beforeEnter: (to, from, next) => {
          verficarPermiso(
            "Recuperaciones",
            "Recuperaciones-Alta Movimientos",
            next,
            permisos.global
          );
        },
      },

      {
        path: `${domain.domainName}/Recuperaciones/EstadisticoRec`,
        name: "EstadisticoRecuperaciones",
        component: EstadisticoRec,
        meta: { title: "Estadistico Rec - Prusia+" },
        props: true,
        beforeEnter: (to, from, next) => {
          verficarPermiso(
            "EstadisticoRecuperaciones",
            "Recuperaciones-Estadistico Recuperaciones",
            next,
            permisos.global
          );
        },
      },
      {
        path: `${domain.domainName}/Recuperaciones/RecuperacionesPendientes`,
        name: "RecuperacionesPendientes",
        component: RecuperacionesPendientes,
        meta: { title: "Recuperaciones Pendientes - Prusia+" },
        props: true,
        beforeEnter: (to, from, next) => {
          verficarPermiso(
            "RecuperacionesPendientes",
            "Recuperaciones-Pendientes Recuperaciones",
            next,
            permisos.global
          );
        },
      },
      {
        path: `${domain.domainName}/Negociaciones/Fianzas`,
        name: "FinanzasPrincipal",
        component: FinanzasPrincipal,
        meta: { title: "Busqueda - Prusia+" },
        props: true,
        beforeEnter: (to, from, next) => {
          verficarPermiso(
            "Fianzas",
            "Fianzas-Principal Fianzas",
            next,
            permisos.global
          );
        },
      },
      {
        path: `${domain.domainName}/Negociaciones/AltaFianzas`,
        name: "AltaFianzas",
        component: AltaFianzas,
        meta: { title: "Alta Fianzas - Prusia+" },
        props: true,
        beforeEnter: (to, from, next) => {
          verficarPermiso(
            "Finanzas",
            "Fianzas-AltaFianzas",
            next,
            permisos.global
          );
        },
      },
      {
        path: `${domain.domainName}/Negociaciones/DetalleFianza`,
        name: "DetalleFianza",
        component: DetalleFianza,
        meta: { title: "Detalle Fianza - Prusia+" },
        props: true,
        beforeEnter: (to, from, next) => {
          verficarPermiso(
            "Finanzas",
            "Fianzas-DetalleFianza",
            next,
            permisos.global
          );
        },
      },
      {
        path: `${domain.domainName}/Negociaciones/AsignarFianza`,
        name: "AsignarFianza",
        component: AsignarFianza,
        meta: { title: "Asignar Fianza - Prusia+" },
        props: true,
        beforeEnter: (to, from, next) => {
          verficarPermiso(
            "Finanzas",
            "Fianzas-AsignarFianza",
            next,
            permisos.global
          );
        },
      },

      {
        path: `${domain.domainName}/Negociaciones/UtilizarFianza`,
        name: "UtilizarFianza",
        component: UtilizarFianza,
        meta: { title: "Utilizar Fianza - Prusia+" },
        props: true,
        beforeEnter: (to, from, next) => {
          verficarPermiso(
            "Finanzas",
            "Fianzas-UtilizarFianza",
            next,
            permisos.global
          );
        },
      },
      {
        path: `${domain.domainName}/Negociaciones/RecibirFianza`,
        name: "RecibirFianza",
        component: RecibirFianza,
        meta: { title: "Recibir Fianza - Prusia+" },
        props: true,
        beforeEnter: (to, from, next) => {
          verficarPermiso(
            "Finanzas",
            "Fianzas-RecibirFianza",
            next,
            permisos.global
          );
        },
      },
      {
        path: `${domain.domainName}/Negociaciones/NotificarFianza`,
        name: "NotificarFianza",
        component: NotificarFianza,
        meta: { title: "Notificar Fianza - Prusia+" },
        props: true,
        beforeEnter: (to, from, next) => {
          verficarPermiso(
            "Finanzas",
            "Fianzas-NotificarFianza",
            next,
            permisos.global
          );
        },
      },

      {
        path: `${domain.domainName}/operacion/tableroDB`,
        name: "tableroDB",
        component: TableroDB,
        meta: { title: "Tablero DB - Prusia+" },
        beforeEnter: (to, from, next) => {
          verficarPermiso(
            "Operacion",
            "Operacion-TableroDashboard",
            next,
            permisos.single.gerente
          );
        },
      },
      {
        path: `${domain.domainName}/GestoriaDocumental`,
        name: "indexGD",
        component: IndexGD,
        meta: { title: "Prusia+" },
        beforeEnter: (to, from, next) => {
          verficarPermiso(to, from, next, permisos.global);
        },
      },
      {
        path: `${domain.domainName}/GestoriaDocumental/CargaLayout`,
        name: "CargaLayout",
        component: CargaLayout,
        meta: { title: "Carga Layout - Prusia+" },
        beforeEnter: (to, from, next) => {
          verficarPermiso(to, from, next, permisos.global);
        },
      },
      {
        path: `${domain.domainName}/BusquedaAvanzada`,
        name: "busquedaAvanzada",
        component: busquedaAvanzada,
        meta: { title: "Busqueda Avanzada - Prusia+" },
        beforeEnter: (to, from, next) => {
          verficarPermiso(
            "Busqueda",
            "Busqueda-BusquedaAvanzada",
            next,
            permisos.global
          );
        },
      },
      {
        path: `${domain.domainName}/Favorito`,
        name: "Favorito",
        component: Favorito,
        meta: { title: "Favorito - Prusia+" },
        beforeEnter: (to, from, next) => {
          verficarPermiso(
            "Favorito",
            "Favorito-Categoria",
            next,
            permisos.global
          );
        },
      },
      {
        path: `${domain.domainName}/Asistencia`,
        name: "Asistencia",
        component: Asistencia,
        meta: { title: "Asistencia - Prusia+" },
        beforeEnter: (to, from, next) => {
          verficarPermiso(
            "Asistencia",
            "Asistencia-Asistencia",
            next,
            permisos.global
          );
        },
      },
      {
        path: `${domain.domainName}/Calidad/RealizarEncuesta`,
        name: "RealizarEncuesta",
        component: RealizarEncuesta,
        meta: { title: "Realizar Encuesta - Prusia+" },
        beforeEnter: (to, from, next) => {
          verficarPermiso(
            "Calidad",
            "Calidad-RealizarEncuesta",
            next,
            permisos.global
          );
        },
      },
      {
        path: `${domain.domainName}/Calidad/EncuestasContestadas`,
        name: "EncuestasContestadas",
        component: EncuestasContestadas,
        meta: { title: "Encuestas Contestadas - Prusia+" },
        beforeEnter: (to, from, next) => {
          verficarPermiso(
            "Calidad",
            "Calidad-EncuestasContestadas",
            next,
            permisos.global
          );
        },
      },

      {
        path: `${domain.domainName}/Calidad/EstadisticaEncuesta`,
        name: "EstadisticaEncuesta",
        component: EstadisticaEncuesta,
        meta: { title: "Estadistica Encuesta - Prusia+" },
        beforeEnter: (to, from, next) => {
          verficarPermiso(
            "Calidad",
            "Calidad-EstadisticaEncuesta",
            next,
            permisos.global
          );
        },
      },
      {
        path: `${domain.domainName}/Calidad/EstadisticaNPS`,
        name: "EstadisticaNPS",
        component: EstadisticaNPS,
        meta: { title: "Estadistica NPS - Prusia+" },
        beforeEnter: (to, from, next) => {
          verficarPermiso(
            "Calidad",
            "Calidad-EstadisticaNPS",
            next,
            permisos.global
          );
        },
      },
      {
        path: `${domain.domainName}/Calidad/MisPendientesNPS`,
        name: "MisPendientesNPS",
        component: MisPendientesNPS,
        meta: { title: "Mis Pendientes NPS - Prusia+" },
        beforeEnter: (to, from, next) => {
          verficarPermiso(
            "Calidad",
            "Calidad-MisPendientesNPS",
            next,
            permisos.global
          );
        },
      },
      {
        path: `${domain.domainName}/Calidad/CalificarAgentes`,
        name: "CalificarAgentes",
        component: CalificarAgentes,
        meta: { title: "Calificar Agentes - Prusia+" },
        beforeEnter: (to, from, next) => {
          verficarPermiso(
            "Calidad",
            "Calidad-CalificarAgentes",
            next,
            permisos.global
          );
        },
      },
      {
        path: `${domain.domainName}/MisPendientes`,
        name: "MainPendientes",
        component: MainPendientes,
        meta: { title: "Mis Pendientes - Prusia+" },
        props: true,
        beforeEnter: (to, from, next) => {
          verficarPermiso(to, from, next, permisos.global);
        },
      },
      {
        path: `${domain.domainName}/MisPendientes/DoctoAdjuntar`,
        name: "doctoAdjuntar",
        component: doctoAdjuntar,
        meta: { title: "Docto Adjuntar - Prusia+" },
        props: true,
        beforeEnter: (to, from, next) => {
          verficarPermiso(to, from, next, permisos.global);
          ContactoRespuesta;
        },
      },
      {
        path: `${domain.domainName}/MisPendientes/DoctoAdjunto`,
        name: "doctoAdjunto",
        component: doctoAdjunto,
        meta: { title: "Docto Adjunto - Prusia+" },
        props: true,
        beforeEnter: (to, from, next) => {
          verficarPermiso(to, from, next, permisos.global);
        },
      },
      {
        path: `${domain.domainName}/MisPendientes/ContactoRespuesta`,
        name: "ContactoRespuesta",
        component: ContactoRespuesta,
        meta: { title: "Contacto Respuesta - Prusia+" },
        props: true,
        beforeEnter: (to, from, next) => {
          verficarPermiso(to, from, next, permisos.global);
        },
      },
      {
        path: `${domain.domainName}/BusquedaGeneral`,
        name: "busquedageneral",
        component: busquedageneral,
        meta: { title: "Busqueda General - Prusia+" },
        beforeEnter: (to, from, next) => {
          verficarPermiso(
            "Busqueda",
            "Busqueda-BusquedaGeneral",
            next,
            permisos.global
          );
        },
      },

      {
        path: `${domain.domainName}/DatosIncompletos`,
        name: "DatosIncompletos",
        component: DatosIncompletos,
        meta: { title: "Datos Incompletos - Prusia+" },
        beforeEnter: (to, from, next) => {
          verficarPermiso(to, from, next, permisos.global);
        },
      },

      {
        path: `${domain.domainName}/GestoriaDocumental/`,
        name: "ReporteGD",
        component: ReporteGD,
        children: [
          {
            path: `${domain.domainName}/GestoriaDocumental/ReporteDetalle`,
            name: "ReporteDetalleGD",
            component: ReporteDetalleGD,
            meta: { title: "Reporte Detalle - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteGD",
                "GD-ReporteDetalle",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/GestoriaDocumental/Seguimiento`,
            name: "ReporteSeguimientoGD",
            meta: { title: "Seguimiento - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                to,
                from,
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
            component: Seguimiento,
          },
          {
            path: `${domain.domainName}/GestoriaDocumental/Seguimiento/AgregarMovimiento`,
            name: "ReporteSeguimientoAgregarMovimientoGD",
            meta: { title: "Agregar Movimiento - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                to,
                from,
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
            component: SeguimientoAgregarMovimiento,
          },
          {
            path: `${domain.domainName}/GestoriaDocumental/Seguimiento/AgregarMovimiento`,
            name: "ReporteAgregarMovimientoGD",
            component: ValidacionAgregarMovimiento,
            meta: { title: "Agregar Movimiento - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                to,
                from,
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/GestoriaDocumental/DocReq`,
            name: "DocumentosGD",
            component: Doc,
            meta: { title: "DocReq - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                to,
                from,
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/GestoriaDocumental/Documentos`,
            name: "DocumentosView",
            component: DocView,
            meta: { title: "Documentos - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteGD",
                "GD-Documentos",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/GestoriaDocumental/Reporte/Citas`,
            name: "citasGD",
            component: Citas,
            meta: { title: "Citas - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteGD",
                "GD-ControlCitas",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/GestoriaDocumental/Archivos`,
            name: "Archivos",
            component: Archivos,
            meta: { title: "Archivos - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteGD",
                "GD-Archivos",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/GestoriaDocumental/Archivos/EnviarCorreo`,
            name: "EnviarCorreo",
            component: EnviarCorreo,
            meta: { title: "Enviar Correo - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteGD",
                "GD-EnviarCorreo",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/GestoriaDocumental/Archivos/AdjuntarDocumento`,
            name: "AdjuntarDocumento",
            component: AdjuntarDocumento,
            meta: { title: "Adjuntar Documento - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteGD",
                "GD-Archivos-AdjuntarDocumento",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/GestoriaDocumental/Archivos/AdjuntarCorreo`,
            name: "AdjuntarCorreo",
            component: AdjuntarCorreo,
            meta: { title: "Adjuntar Correo - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteGD",
                "GD-Archivos-AdjuntarCorreo",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/GestoriaDocumental/Archivos/AdjuntarLlamada`,
            name: "AdjuntarLlamada",
            component: AdjuntarLlamada,
            meta: { title: "Adjuntar Llamada - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteGD",
                "GD-Archivos-AdjuntarLlamada",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/GestoriaDocumental/Documentos/docCalif`,
            name: "docCalif",
            component: DocCalif,
            meta: { title: "docCalif - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteGD",
                "GD-Archivos-docCalif",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/GestoriaDocumental/Seguimiento/Tramites`,
            name: "Tramites",
            component: Tramites,
            meta: { title: "Tramites - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                to,
                from,
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/GestoriaDocumental/Demeritos`,
            name: "Demeritos",
            component: Demeritos,
            meta: { title: "Demeritos - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                to,
                from,
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/GestoriaDocumental/ConfirmacionDocumentosAusa`,
            name: "DoctosAusa",
            component: DoctosAusa,
            meta: { title: "Confirmación Documentos - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                to,
                from,
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
        ],
      },
      {
        path: `${domain.domainName}/Reporte/Movimientos`,
        name: "Movimientos",
        component: Movimientos,
      },
      {
        path: `docReq`,
        name: "docReq",
        component: Doc,
      },
      {
        path: `VistaDocs`,
        name: "VistaDocs",
        component: DocView,
      },
      {
        path: `Whatsapp`,
        name: "Whatsapp",
        component: Whatsapp,
        meta: { title: "Whatsapp" },
        beforeEnter: async (to, from, next) => {
          let datos = await MetodosGenrales.obtenerSessionReporte("reporte");
          verficarPermiso(
            "WhatsApp",
            "WS-ConversacionesWhatsApp",
            next,
            permisos.global,
            datos.nrreporte,
            datos.svindice
          );
        },
      },
      {
        path: `${domain.domainName}/MisPendientesWhatsApp`,
        name: "MisPendientesWhatsApp",
        component: MisPendientesWhatsApp,
        meta: { title: "Whatsapp - MisPendientes" },
        props: true,
        beforeEnter: async (to, from, next) => {
          verficarPermiso(
            "WhatsApp",
            "WhatsApp-MisPendientes",
            next,
            permisos.global
          );
        },
      },

      {
        path: `${domain.domainName}/Proveedor/DetalleAbogado`,
        name: "DetalleAbogado",
        component: DetalleAbogadoRep,
        meta: { title: "Detalle Abogado - Prusia+" },
        props: true,
        beforeEnter: async (to, from, next) => {
          let datos = await MetodosGenrales.obtenerSessionReporte("reporte");
          verficarPermiso(
            "Proveedor",
            "PR-DetalleProveedor",
            next,
            permisos.global,
            datos.nrreporte,
            datos.svindice
          );
        },
      },

      /* {
                                  path: `docCalif`,
                                  name: "docCalif",
                                  component: DocCalif
                  
                              }, */

      {
        path: `${domain.domainName}/TramitePago/Inicio`,
        name: "Inicio",
        component: Inicio,
        meta: { title: "Trámite Pago - Prusia+" },
        children: [
          {
            path: `${domain.domainName}/TramitePago/ReportesAbogado`,
            name: "ReportesAbogado",
            component: ReportesAbogado,
            meta: { title: "Reportes Abogado - Prusia+" },
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "TramitePago",
                "TP-ReportesAbogado",
                next,
                permisos.global
              );
            },
          },
          {
            path: `${domain.domainName}/TramitePago/EnvioTramite`,
            name: "EnvioTramite",
            component: EnvioTramite,
            meta: { title: "Envio Trámite - Prusia+" },
            props: true,
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "TramitePago",
                "TP-EnvioTramite",
                next,
                permisos.global
              );
            },
          },
          {
            path: `${domain.domainName}/TramitePago/DocumentoPendiente`,
            name: "DoctoPendiente",
            component: DoctoPendiente,
            meta: { title: "Documento Pendiente - Prusia+" },
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "TramitePago",
                "TP-DocumentoPendiente",
                next,
                permisos.global
              );
            },
          },
          {
            path: `${domain.domainName}/TramitePago/RecepcionDocto`,
            name: "RecepcionDocto",
            component: RecepcionDocto,
            meta: { title: "Recepción Docto - Prusia+" },
            props: true,
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "TramitePago",
                "TP-RecepcionDocto",
                next,
                permisos.global
              );
            },
          },
          {
            path: `${domain.domainName}/TramitePago/ReportesPendientes`,
            name: "ReportesPendientes",
            component: ReportesPendientes,
            meta: { title: "Reportes Pendientes - Prusia+" },
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "TramitePago",
                "TP-ReportesPendientes",
                next,
                permisos.global
              );
            },
          },
          {
            path: `${domain.domainName}/TramitePago/EnviarDocto`,
            name: "EnviarDocto",
            component: EnviarDocto,
            meta: { title: "Enviar Docto - Prusia+" },
            props: true,
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "TramitePago",
                "TP-EnviarDocto",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/TramitePago/DoctoTramite`,
            name: "DoctoTramite",
            component: DoctoTramite,
            meta: { title: "Docto Trámite - Prusia+" },
            props: true,
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "TramitePago",
                "TP-DoctoTramite",
                next,
                permisos.global
              );
            },
          },
          {
            path: `${domain.domainName}/TramitePago/RecibirReporte`,
            name: "RecibirReporte",
            component: RecibirReporte,
            meta: { title: "Recibir Reporte - Prusia+" },
            props: true,
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "TramitePago",
                "TP-RecibirReporte",
                next,
                permisos.global
              );
            },
          },
          {
            path: `${domain.domainName}/TramitePago/DoctoPendienteRecibir`,
            name: "DoctoPendienteRecibir",
            component: DoctoPendienteRecibir,
            meta: { title: "Docto Pendiente Recibir - Prusia+" },
            props: true,
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "TramitePago",
                "TP-DoctoPendienteRecibir",
                next,
                permisos.global
              );
            },
          },
          {
            path: `${domain.domainName}/TramitePago/ReportesPendientePagar`,
            name: "ReportesPendientePagar",
            component: ReportesPendientePagar,
            meta: { title: "Reportes Pendiente Pagar - Prusia+" },
            props: true,
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "TramitePago",
                "TP-ReportesPendientePagar",
                next,
                permisos.global
              );
            },
          },
          {
            path: `${domain.domainName}/TramitePago/ValidaReporte`,
            name: "ValidaReporte",
            component: ValidaReporte,
            meta: { title: "Valida Reporte - Prusia+" },
            props: true,
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "TramitePago",
                "TP-ValidaReporte",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/TramitePago/ProcesoPago`,
            name: "ProcesoPago",
            component: ProcesoPago,
            meta: { title: "Proceso Pago - Prusia+" },
            props: true,
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "TramitePago",
                "TP-ProcesoPago",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/TramitePago/ReportePendienteValidar`,
            name: "ReportePendienteValidar",
            component: ReportePendienteValidar,
            meta: { title: "Reporte Pendiente Validar - Prusia+" },
            props: true,
            beforeEnter: (to, from, next) => {
              verficarPermiso("TramitePago", "TP-", next, permisos.global);
            },
          },
          {
            path: `${domain.domainName}/TramitePago/SolicitarFactura`,
            name: "SolicitarFactura",
            component: SolicitarFactura,
            meta: { title: "Solicitar Factura - Prusia+" },
            props: true,
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "TramitePago",
                "TP-ReportePendienteValidar",
                next,
                permisos.global
              );
            },
          },
          {
            path: `${domain.domainName}/TramitePago/EnvioSolicitudFactura`,
            name: "EnvioSolicitudFactura",
            component: EnvioSolicitudFactura,
            meta: { title: "Envío Solicitud Factura - Prusia+" },
            props: true,
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "TramitePago",
                "TP-EnvioSolicitudFactura",
                next,
                permisos.global
              );
            },
          },
          {
            path: `${domain.domainName}/TramitePago/EnvioFacturas`,
            name: "EnvioFacturas",
            component: EnvioFacturas,
            meta: { title: "Envío Facturas - Prusia+" },
            props: true,
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "TramitePago",
                "TP-EnvioFacturas",
                next,
                permisos.global
              );
            },
          },
          {
            path: `${domain.domainName}/TramitePago/AdjuntarFactura`,
            name: "AdjuntarFactura",
            component: AdjuntarFactura,
            meta: { title: "Adjuntar Factura - Prusia+" },
            props: true,
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "TramitePago",
                "TP-AdjuntarFactura",
                next,
                permisos.global
              );
            },
          },
          {
            path: `${domain.domainName}/TramitePago/ListadoContrarecibo`,
            name: "ListadoContrarecibo",
            component: ListadoContrarecibo,
            meta: { title: "Listado Contrarecibo - Prusia+" },
            props: true,
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "TramitePago",
                "TP-ListadoContrarecibo",
                next,
                permisos.global
              );
            },
          },
          {
            path: `${domain.domainName}/TramitePago/RealizarPago`,
            name: "RealizarPago",
            component: RealizarPago,
            meta: { title: "Realizar Pago - Prusia+" },
            props: true,
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "TramitePago",
                "TP-RealizarPago",
                next,
                permisos.global
              );
            },
          },
          {
            path: `${domain.domainName}/TramitePago/CargarRegistros`,
            name: "CargarRegistros",
            component: CargarRegistros,
            meta: { title: "Cargar Registros - Prusia+" },
            beforeEnter: (to, from, next) => {
              verficarPermiso(
                "TramitePago",
                "TP-CargarRegistros",
                next,
                permisos.global
              );
            },
          },
        ],
      },
      {
        path: `${domain.domainName}/Lideres`,
        name: "LideresMain",
        component: LideresMain,
        meta: { title: "Lideres - Prusia+" },
        beforeEnter: async (to, from, next) => {
          verficarPermiso(
            "Lideres",
            "Lideres-Principal",
            next,
            permisos.global
          );
        },
      },
      {
        path: `${domain.domainName}/LevantarQueja`,
        name: "LevantarQueja",
        component: LevantarQueja,
        meta: { title: "Levantar Queja - Prusia+" },
        beforeEnter: async (to, from, next) => {
          verficarPermiso(
            "Quejas",
            "Quejas-LevantarQueja",
            next,
            permisos.global
          );
        },
      },
      {
        path: `${domain.domainName}/QuejasAdministracion`,
        name: "QuejasAdministracion",
        component: QuejasAdministracion,
        meta: { title: "Quejas Administración - Prusia+" },
        beforeEnter: async (to, from, next) => {
          verficarPermiso(
            "Quejas",
            "Quejas-QuejasAdministracion",
            next,
            permisos.global
          );
        },
      },
      {
        path: `${domain.domainName}/DetalleQueja`,
        name: "DetalleQueja",
        component: DetalleQueja,
        meta: { title: "Detalle Queja - Prusia+" },
        beforeEnter: async (to, from, next) => {
          verficarPermiso(
            "Quejas",
            "Quejas-DetalleQueja",
            next,
            permisos.global
          );
        },
      },
      {
        path: `${domain.domainName}/QuejasPendientes`,
        name: "QuejasPendientes",
        component: QuejasPendientes,
        meta: { title: "Quejas Pendientes - Prusia+" },
        beforeEnter: async (to, from, next) => {
          verficarPermiso(
            "Quejas",
            "Quejas-QuejasPendientes",
            next,
            permisos.global
          );
        },
      },
      {
        path: `${domain.domainName}/Lideres/AgregarMovimientoValider`,
        name: "AgregarMovimientoValider",
        component: AgregarMovimientoValider,
        meta: { title: "Agregar Movimiento Valider - Prusia+" },
        beforeEnter: async (to, from, next) => {
          verficarPermiso("Lideres", "Lideres-Valider", next, permisos.global);
        },
      },
      {
        path: `${domain.domainName}/Lideres/PantallaAjustador`,
        name: "PantallaAjustador",
        component: PantallaAjustador,
        meta: { title: "Pantalla Ajustador - Prusia+" },
        beforeEnter: async (to, from, next) => {
          verficarPermiso(
            "Lideres",
            "Lideres-PantallaAjustador",
            next,
            permisos.global
          );
        },
      },
      {
        path: `${domain.domainName}/Lideres/PantallaNA`,
        name: "PantallaNA",
        component: PantallaNA,
        meta: { title: "Pantalla NA - Prusia+" },
        beforeEnter: async (to, from, next) => {
          verficarPermiso(
            "Lideres",
            "Lideres-PantallaNA",
            next,
            permisos.global
          );
        },
      },
      {
        path: `${domain.domainName}/Lideres/PantallaAB`,
        name: "PantallaAB",
        component: PantallaAB,
        meta: { title: "Pantalla AB - Prusia+" },
        beforeEnter: async (to, from, next) => {
          verficarPermiso(
            "Lideres",
            "Lideres-PantallaAB",
            next,
            permisos.global
          );
        },
      },
      {
        path: `${domain.domainName}/Lideres/ReasignacionLideres`,
        name: "ReasignacionLideres",
        component: ReasignacionLideres,
        meta: { title: "Reasignación Lideres - Prusia+" },
        beforeEnter: async (to, from, next) => {
          verficarPermiso(
            "Lideres",
            "Lideres-ReasignacionLideres",
            next,
            permisos.global
          );
        },
      },
      {
        path: `${domain.domainName}/Lideres/Notificaciones`,
        name: "Notificaciones",
        component: Notificaciones,
        meta: { title: "Notificaciones - Prusia+" },
        beforeEnter: async (to, from, next) => {
          verficarPermiso(
            "Lideres",
            "Lideres-Notificaciones",
            next,
            permisos.global
          );
        },
      },
      {
        path: `${domain.domainName}/Lideres/CriterioLider`,
        name: "CriterioLider",
        component: CriterioLider,
        meta: { title: "Criterio Líder - Prusia+" },
        beforeEnter: async (to, from, next) => {
          verficarPermiso(
            "Lideres",
            "Lideres-CriterioLider",
            next,
            permisos.global
          );
        },
      },
      {
        path: `${domain.domainName}/Lideres/Indicios`,
        name: "Indicios",
        component: Indicios,
        meta: { title: "Indicios - Prusia+" },
        beforeEnter: async (to, from, next) => {
          verficarPermiso("Lideres", "Lideres-Indicios", next, permisos.global);
        },
      },
      {
        path: `${domain.domainName}/Lideres/DatosPrueba`,
        name: "DatosPrueba",
        component: DatosPrueba,
        meta: { title: "Datos Prueba - Prusia+" },
        beforeEnter: async (to, from, next) => {
          verficarPermiso(
            "Lideres",
            "Lideres-DatosPrueba",
            next,
            permisos.global
          );
        },
      },
      {
        path: `${domain.domainName}/Lideres/Precierre`,
        name: "Precierre",
        component: Precierre,
        meta: { title: "Precierre - Prusia+" },
        beforeEnter: async (to, from, next) => {
          verficarPermiso(
            "Lideres",
            "Lideres-Precierre",
            next,
            permisos.global
          );
        },
      },
      {
        path: `${domain.domainName}/Finanzas/AdminContrarecibo`,
        name: "AdminContrarecibo",
        component: AdminContrarecibo,
        meta: { title: "Admin Contrarecibo - Prusia+" },
        beforeEnter: async (to, from, next) => {
          verficarPermiso(
            "Finanzas",
            "Finanzas-AdminContrarecibo",
            next,
            permisos.global
          );
        },
      },
      {
        path: `${domain.domainName}/Vacaciones/Solicitar`,
        name: "SolicitarVacaciones",
        component: Solicitud,
        meta: { title: "Solicitar - Prusia+" },
        beforeEnter: async (to, from, next) => {
          verficarPermiso(
            "Vacaciones",
            "Vacaciones-SolicitarVacaciones",
            next,
            permisos.global
          );
        },
      },
      {
        path: `${domain.domainName}/Vacaciones/Autorizar`,
        name: "AutorizarVacaciones",
        component: Autorizar,
        meta: { title: "Autorizar - Prusia+" },
        beforeEnter: async (to, from, next) => {
          verficarPermiso(
            "Vacaciones",
            "Vacaciones-AutorizarVacaciones",
            next,
            permisos.global
          );
        },
      },

      {
        path: `${domain.domainName}/Asistencias/`,
        name: "Asistencias",
        component: Asistencias,
        meta: { title: "Reporte Detalle - Prusia+" },
        children: [
          {
            path: `${domain.domainName}/Civil/ReporteDetalle`,
            name: "DetalleCivil",
            component: DetalleCivil,
            meta: { title: "Reporte Detalle - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteCivil",
                "Civil-ReporteDetalle",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/Civil/MovimientoGeneral`,
            name: "MovimientoGeneralCivil",
            component: MovimientoGeneral,
            meta: { title: "Movimiento General - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteCivil",
                "Civil-MovimientoGeneral",
                next,
                permisos.global,
                datos.nrreporte
              );
            },
          },
          {
            path: `${domain.domainName}/Civil/AgregarMovimientos/:tokenData`,
            name: "AgregarMovimientosCivil",
            component: AgregarMovimientosCivil,
            meta: { title: "Agregar Movimientos - Prusia+" },
            props: true,
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteCivil",
                "Civil-AgregarMovimiento",
                next,
                permisos.global,
                datos.nrreporte
              );
            },
          },
          {
            path: `${domain.domainName}/Civil/MovimientoTramite/:tokenData`,
            name: "MovimientoTramiteCivil",
            component: MovimientoTramite,
            meta: { title: "Movimiento Trámite - Prusia+" },
            props: true,
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteCivil",
                "Civil-MovimientoTramite",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/Civil/AutorizarConclusion`,
            name: "AutorizarConclusionCivil",
            component: AutorizarConclusion,
            meta: { title: "Autorizar Conclusión - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteCivil",
                "Civil-AutorizarConclusion",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/Civil/ConcluirConclusion`,
            name: "ConcluirConclusionCivil",
            component: ConcluirConclusion,
            meta: { title: "Conclusión - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteCivil",
                "Civil-ConcluirConclusion",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/Civil/Archivos/CalificarDocs`,
            name: "CalificarDocumentosCivil",
            component: CalificarDocs,
            meta: { title: "Calificar Docs - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteCivil",
                "Civil-Archivos-CalificarDocs",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/Civil/Archivos/Reclasificacion`,
            name: "ReclasificacionCivil",
            component: Reclasificacion,
            meta: { title: "Reclasificacion - Prusia+" },
            prop: true,
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "Civil",
                "Civil-Archivos-Reclasificacion",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/Civil/Archivos/DividirPDF`,
            name: "ExpedienteCivil",
            component: DividirPDF,
            meta: { title: "Dividir PDF - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteCivil",
                "Civil-Archivos-DividirPDF",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/Civil/Archivos/DocumentosNoConforme`,
            name: "DocumentosNoConformesCivil",
            component: DocumentoNoConformes,
            meta: { title: "Documentos No Conforme - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteCivil",
                "Civil-Archivos-DocumentosNoConforme",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/Civil/Archivos/ExportarPDF`,
            name: "ExportarPDFCivil",
            component: ExportarPDF,
            meta: { title: "Exportar PDF - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteCivil",
                "Civil-Archivos-ExportarPDF",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/Civil/Archivos/AdjuntarLlamada`,
            name: "AdjuntarLlamadaCivil",
            component: AdjuntarLlamada,
            meta: { title: "Adjuntar Llamada - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteCivil",
                "Civil-Archivos-AdjuntarLlamada",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/Civil/Archivos`,
            name: "ArchivosCivil",
            component: Archivos,
            meta: { title: "Archivos - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteCivil",
                "Civil-Archivos",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/Civil/Archivos/AdjuntarDocumento`,
            name: "AdjuntarDocumentoCivil",
            component: AdjuntarDocumento,
            meta: { title: "Adjuntar Documento - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteCivil",
                "Civil-Archivos-AdjuntarDocumento",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/Civil/Archivos/AdjuntarVideo`,
            name: "AdjuntarVideoCivil",
            component: AdjuntarVideo,
            meta: { title: "Adjuntar Video - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteCivil",
                "Civil-Archivos-AdjuntarVideo",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/Civil/Archivos/AdjuntarCorreo`,
            name: "AdjuntarCorreoCivil",
            component: AdjuntarCorreo,
            meta: { title: "Adjuntar Correo - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteCivil",
                "Civil-Archivos-AdjuntarCorreo",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/Civil/Reporte/Citas`,
            name: "citasCivil",
            component: Citas,
            meta: { title: "Citas - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteCivil",
                "Civil-ControlCitas",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/Civil/SolicitarDesconclusion`,
            name: "SolicitarDesconCivil",
            component: SolicitarCon,
            meta: { title: "Solicitar Desconclusión - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteCivil",
                "Civil-SolicitarDesconclusion",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/Civil/AutorizarDesconclusion`,
            name: "AutorizarDesconCivil",
            component: AutorizarCon,
            meta: { title: "Autorizar Desconclusión - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteCivil",
                "Civil-AutorizarDesconclusion",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/Civil/Seguimiento`,
            name: "SeguimientoGeneralCivil",
            component: SeguimientoGeneral,
            meta: { title: "Seguimiento - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteCivil",
                "Civil-Seguimiento",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/Civil/Garantias`,
            name: "GarantiasCivil",
            component: Garantias,
            meta: { title: "Garantias - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteCivil",
                "Civil-Garantias",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/Civil/ImpulsosProcesales`,
            name: "ImpulsosProcesalesCivil",
            meta: { title: "ImpulsosProcesales - Prusia+" },
            component: ImpulsosProcesales,
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteCivil",
                "Civil-ImpulsosProcesales",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/Civil/Garantias/SolicitarPago`,
            name: "SolicitarPagoCivil",
            component: SolicitarPago,
            meta: { title: "Solicitar Pago - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteCivil",
                "Civil-Garantias-SolicitarPago",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/Civil/Garantias/FormatoSolicitud`,
            name: "FormatoSolicitudCivil",
            component: FormatoSolicitud,
            meta: { title: "Formato Solicitud - Prusia+" },
            props: true,
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteCivil",
                "Civil-Garantias-FormatoSolicitud",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/Civil/Garantias/PresolicitudPago`,
            name: "PresolicitudPagoCivil",
            component: PresolicitudPago,
            meta: { title: "Presolicitud Pago - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteCivil",
                "Civil-Garantias-PresolicitudPago",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/Civil/Garantias/AutorizarPago/`,
            name: "AutorizarPagoCivil",
            component: AutorizarPago,
            meta: { title: "Autorizar Pago - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteCivil",
                "Civil-Garantias-AutorizarPago",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/Civil/Desconclusion`,
            name: "DesconclusionCivil",
            component: Desconclusion,
            meta: { title: "Desconclusión - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteCivil",
                "Civil-Desconclusion",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/Civil/Notas`,
            name: "Notas",
            component: Notas,
            meta: { title: "Notas - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteCivil",
                "Civil-Notas",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/Civil/Reasignacion`,
            name: "ReasignacionCivil",
            component: Reasignacion,
            meta: { title: "Reasignación - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteCivil",
                "Civil-Reasignacion",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/Civil/ReasignacionLider`,
            name: "ReasignacionLiderCivil",
            component: ReasignacionLider,
            meta: { title: "Reasignación Lider - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteCivil",
                "Civil-ReasignacionLider",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/Civil/EditarMovimiento`,
            name: "EditarMovimientoCivil",
            component: EditarMovimiento,
            meta: { title: "Editar Movimiento - Prusia+" },
            props: true,
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteCivil",
                "Civil-Movimiento-EditarMovimiento",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/ExpJur/ReporteDetalle`,
            name: "DetalleExpJur",
            component: DetalleExpJur,
            meta: { title: "Reporte Detalle - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteJur",
                "AJ-ReporteDetalle",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/ExpJur/ConcluirDanos`,
            name: "ConcluirDanos",
            component: Danos,
            meta: { title: "Concluir Daños - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteJur",
                "AJ-Volante-ConcluirDanos",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/ExpJur/ConcluirLesiones`,
            name: "ConcluirLesiones",
            component: Lesiones,
            meta: { title: "Concluir Lesiones - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteJur",
                "AJ-Volante-ConcluirLesiones",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },

          {
            path: `${domain.domainName}/ExpJur/InfoConclusionDanos`,
            name: "InfoConclusionDanos",
            component: ConclusionDanos,
            meta: { title: "Info Conclusión Danos - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteJur",
                "AJ-Volante-InfoConclusionDanos",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/ExpJur/InfoConclusionLesiones`,
            name: "InfoConclusionLesiones",
            component: ConclusionLesiones,
            meta: { title: "Info Conclusión Lesiones - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteJur",
                "AJ-Volante-InfoConclusionLesiones",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/ExpJur/ListadoNegociaciones`,
            name: "ListadoNegociaciones",
            component: ListadoNegociaciones,
            meta: { title: "Listado Negociaciones - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteJur",
                "AJ-Volante-ListadoNegociaciones",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/ExpJur/AltaMovimientoNegociacion`,
            name: "AltaMovimientoNegociacion",
            component: AltaMovimiento,
            meta: { title: "Alta Movimiento Negociación - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteJur",
                "AJ-Volante-AltaMovimientoNegociacion",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/ExpJur/ValidacionNegociacion`,
            name: "ValidacionNegociacion",
            component: ValidacionNegociacion,
            meta: { title: "Validacion Negociación - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteJur",
                "AJ-Volante-ValidacionNegociacion",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/ExpJur/Recuperacion`,
            name: "Recuperacion",
            component: Recuperacion,
            meta: { title: "Recuperación - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteJur",
                "AJ-Volante-Recuperacion",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/ExpJur/SinNegociacion`,
            name: "SinNegociacion",
            component: SinNegociacion,
            meta: { title: "Sin Negociación - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteJur",
                "AJ-Volante-SinNegociacion",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/ExpJur/MovimientoGeneral`,
            name: "MovimientoGeneralExpJur",
            component: MovimientoGeneral,
            meta: { title: "Movimiento General - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteJur",
                "AJ-MovimientoGeneral",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/ExpJur/AgregarMovimientos/:tokenData`,
            name: "AgregarMovimientosExpJur",
            component: AgregarMovimientosExpJur,
            meta: { title: "Agregar Movimientos - Prusia+" },
            props: true,
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteJur",
                "AJ-AgregarMovimiento",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/ExpJur/LiberacionVeh`,
            name: "LiberacionVehExpJur",
            component: LiberacionVehExpJur,
            meta: { title: "Liberación Veh - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteJur",
                "AJ-LiberacionVehicular",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/ExpJur/Volante`,
            name: "VolanteExpJur",
            component: VolanteExpJur,
            meta: { title: "Volante - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteJur",
                "AJ-Volante",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/ExpJur/EditarMovimiento`,
            name: "EditarMovimientoExpJur",
            component: EditarMovimiento,
            meta: { title: "Editar Movimiento - Prusia+" },
            props: true,
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteJur",
                "AJ-Movimiento-EditarMovimiento",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/ExpJur/Archivos`,
            name: "ArchivosExpJur",
            component: Archivos,
            meta: { title: "Archivos - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteJur",
                "AJ-Archivos",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/ExpJur/Archivos/AdjuntarCorreo`,
            name: "AdjuntarCorreoExpJur",
            component: AdjuntarCorreo,
            meta: { title: "Adjuntar Correo - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteJur",
                "AJ-Archivos-AdjuntarCorreo",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/ExpJur/Archivos/AdjuntarLlamada`,
            name: "AdjuntarLlamadaExpJur",
            component: AdjuntarLlamada,
            meta: { title: "Adjuntar Llamada - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteJur",
                "AJ-Archivos-AdjuntarLlamada",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/ExpJur/Archivos/AdjuntarVideo`,
            name: "AdjuntarVideoExpJur",
            component: AdjuntarVideo,
            meta: { title: "Adjuntar Video - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteJur",
                "AJ-Archivos-AdjuntarVideo",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/ExpJur/Archivos/EnviarCorreo`,
            name: "EnviarCorreoExpJur",
            component: EnviarCorreo,
            meta: { title: "Enviar Correo - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteJur",
                "AJ-Archivos-EnviarCorreo",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/ExpJur/Archivos/CalificarDocs`,
            name: "CalificarDocumentosExpJur",
            component: CalificarDocs,
            meta: { title: "Calificar Docs - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteJur",
                "AJ-Archivos-CalificarDocs",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/ExpJur/Archivos/DocumentosNoConforme`,
            name: "DocumentosNoConformesExpJur",
            component: DocumentoNoConformes,
            meta: { title: "Documentos No Conforme - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteJur",
                "AJ-Archivos-DocumentosNoConforme",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/ExpJur/Archivos/AdjuntarDocumento`,
            name: "AdjuntarDocumentoEJ",
            component: AdjuntarDocumento,
            meta: { title: "Adjuntar Documento - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteJur",
                "AJ-Archivos-AdjuntarDocumento",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/ExpJur/Archivos/ExportarPDF`,
            name: "ExportarPDFEJ",
            component: ExportarPDF,
            meta: { title: "Exportar PDF - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteJur",
                "AJ-Archivos-ExportarPDF",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/ExpJur/Archivos/Reclasificacion`,
            name: "Reclasificacion",
            component: Reclasificacion,
            meta: { title: "Reclasificación - Prusia+" },
            prop: true,
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteJur",
                "AJ-Archivos-Reclasificacion",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/ExpJur/Archivos/DividirPDF`,
            name: "DividirPDFJur",
            component: DividirPDF,
            meta: { title: "Dividir PDF - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteJur",
                "AJ-Archivos-DividirPDF",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/ExpJur/ReasignacionLider`,
            name: "ReasignacionLiderExpJur",
            component: ReasignacionLider,
            meta: { title: "Reasignación Lider - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteJur",
                "AJ-ReasignacionLider",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/ExpJur/Seguimiento`,
            name: "SeguimientoGeneralExpJur",
            component: SeguimientoGeneral,
            meta: { title: "Seguimiento - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteJur",
                "AJ-Seguimiento",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/ExpJur/Cobros`,
            name: "AcompanamientoPA",
            component: AcompanaPA,
            meta: { title: "Cobros - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteJur",
                "AJ-Cobros",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/ExpJur/Reporte/Citas`,
            name: "citasExpJur",
            component: Citas,
            meta: { title: "Citas - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteJur",
                "AJ-ControlCitas",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/ExpJur/Garantias`,
            name: "GarantiasExpJur",
            component: Garantias,
            meta: { title: "Garantias - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteJur",
                "AJ-Garantias",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/ExpJur/ImpulsosProcesales`,
            name: "ImpulsosProcesalesExpJur",
            meta: { title: "ImpulsosProcesales - Prusia+" },
            component: ImpulsosProcesales,
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteJur",
                "AJ-ImpulsosProcesales",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/ExpJur/Garantias/SolicitarPago`,
            name: "SolicitarPagoExpJur",
            component: SolicitarPago,
            meta: { title: "Solicitar Pago - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteJur",
                "AJ-Garantias-SolicitarPago",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/ExpJur/Garantias/FormatoSolicitud`,
            name: "FormatoSolicitudExpJur",
            component: FormatoSolicitud,
            meta: { title: "Formato Solicitud - Prusia+" },
            props: true,
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteJur",
                "AJ-Garantias-FormatoSolicitud",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/ExpJur/Garantias/PresolicitudPago`,
            name: "PresolicitudPagoExpJur",
            component: PresolicitudPago,
            meta: { title: "Presolicitud Pago - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteJur",
                "AJ-Garantias-PresolicitudPago",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/ExpJur/Garantias/AutorizarPago/`,
            name: "AutorizarPagoExpJur",
            component: AutorizarPago,
            meta: { title: "Autorizar Pago - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteJur",
                "AJ-Garantias-AutorizarPago",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/ExpJur/Contraloria`,
            name: "ContraloriaExpJur",
            component: Contralorias,
            meta: { title: "Contraloría - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteJur",
                "AJ-Contraloria",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/ExpJur/Desconclusion`,
            name: "DesconclusionExpJur",
            component: Desconclusion,
            meta: { title: "Desconclusion - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteJur",
                "AJ-Desconclusion",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/ExpJur/ConcluirConclusion`,
            name: "ConcluirConclusionExpJur",
            component: ConcluirConclusion,
            meta: { title: "Conclusión - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteJur",
                "AJ-ConcluirConclusion",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/ExpJur/MovimientoTramite/:tokenData`,
            name: "MovimientoTramite",
            component: MovimientoTramite,
            meta: { title: "Movimiento Tramite - Prusia+" },
            props: true,
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteJur",
                "AJ-MovimientoTramite",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/ExpJur/Civil`,
            name: "Civil",
            component: Civil,
            meta: { title: "Civil - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteJur",
                "AJ-Civil",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/ExpJur/AutorizarConclusion`,
            name: "AutorizarConclusionExpJur",
            component: AutorizarConclusion,
            meta: { title: "Autorizar Conclusión - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteJur",
                "AJ-AutorizarConclusion",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/ExpJur/SolicitarDesconclusion`,
            name: "SolicitarDesconExpJur",
            component: SolicitarCon,
            meta: { title: "Solicitar Desconclusión - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteJur",
                "AJ-SolicitarDesconclusion",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/ExpJur/AutorizarDesconclusion`,
            name: "AutorizarDesconExpJur",
            component: AutorizarCon,
            meta: { title: "Autorizar Desconclusión - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteJur",
                "AJ-AutorizarDesconclusion",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/ExpJur/Reasignacion`,
            name: "ReasignacionExpJur",
            component: Reasignacion,
            meta: { title: "Reasignación - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteJur",
                "AJ-Reasignacion",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/ExpJur/Honorario`,
            name: "HonorarioExpJur",
            component: Honorario,
            meta: { title: "Honorario - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteJur",
                "AJ-Honorario",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/ExpJur/Notas`,
            name: "Notas",
            component: Notas,
            meta: { title: "Notas - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteJur",
                "AJ-Notas",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          //////////////////////////////////////////////////////////////////////////////////
          {
            path: `${domain.domainName}/Robo/ReporteDetalle`,
            name: "DetalleRobo",
            component: DetalleRobo,
            meta: { title: "Reporte Detalle - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRobo",
                "Robo-ReporteDetalle",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/Robo/Archivos/AdjuntarCorreo`,
            name: "AdjuntarCorreoRobo",
            component: AdjuntarCorreo,
            meta: { title: "Adjuntar Correo - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRobo",
                "Robo-Archivos-AdjuntarCorreo",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/Robo/Archivos/CalificarDocs`,
            name: "CalificarDocumentosRobo",
            component: CalificarDocs,
            meta: { title: "Calificar Docs - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRobo",
                "Robo-Archivos-CalificarDocs",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/Robo/Notas`,
            name: "NotasRobo",
            component: Notas,
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRobo",
                "Robo-Notas",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/Robo/Archivos/DocumentosNoConforme`,
            name: "DocumentosNoConformesRobo",
            component: DocumentoNoConformes,
            meta: { title: "Documentos No Conforme - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRobo",
                "Robo-Archivos-DocumentosNoConforme",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/Robo/Archivos/ExportarPDF`,
            name: "ExportarPDFRobo",
            component: ExportarPDF,
            meta: { title: "Exportar PDF - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRobo",
                "Robo-Archivos-ExportarPDF",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/Robo/Archivos/AdjuntarLlamada`,
            name: "AdjuntarLlamadaRobo",
            component: AdjuntarLlamada,
            meta: { title: "Adjuntar Llamada - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRobo",
                "Robo-Archivos-AdjuntarLlamada",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/Robo/Archivos`,
            name: "ArchivosRobo",
            component: Archivos,
            meta: { title: "Archivos - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRobo",
                "Robo-Archivos",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/Robo/Archivos/AdjuntarDocumento`,
            name: "AdjuntarDocumentoRobo",
            component: AdjuntarDocumento,
            meta: { title: "Adjuntar Documento - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRobo",
                "Robo-Archivos-AdjuntarDocumento",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/Robo/Archivos/DividirPDF`,
            name: "DividirPDFRobo",
            component: DividirPDF,
            meta: { title: "Dividir PDF - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRobo",
                "Robo-Archivos-DividirPDF",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/Robo/Archivos/AdjuntarVideo`,
            name: "AdjuntarVideoRobo",
            component: AdjuntarVideo,
            meta: { title: "Adjuntar Video - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRobo",
                "Robo-Archivos-AdjuntarVideo",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/Robo/MovimientoGeneral`,
            name: "MovimientoGeneralRobo",
            component: MovimientoGeneral,
            meta: { title: "Movimiento General - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRobo",
                "Robo-MovimientoGeneral",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/Robo/AgregarMovimientos/:tokenData`,
            name: "AgregarMovimientosRobo",
            component: AgregarMovimientosRobo,
            meta: { title: "Agregar Movimientos - Prusia+" },
            props: true,
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRobo",
                "Robo-AgregarMovimiento",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/Robo/LiberacionVeh`,
            name: "LiberacionVehRobo",
            component: LiberacionVehRobo,
            meta: { title: "Liberación Veh - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRobo",
                "Robo-LiberacionVehicular",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/Robo/EditarMovimiento`,
            name: "EditarMovimientoRobo",
            component: EditarMovimiento,
            meta: { title: "Editar Movimiento - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRobo",
                "Robo-Movimiento-EditarMovimiento",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/Robo/Reasignacion`,
            name: "ReasignacionRobo",
            component: Reasignacion,
            meta: { title: "Reasignación - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRobo",
                "Robo-Reasignacion",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/Robo/ReasignacionLider`,
            name: "ReasignacionLiderRobo",
            component: ReasignacionLider,
            meta: { title: "Reasignación Lider - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRobo",
                "Robo-ReasignacionLider",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/Robo/Seguimiento`,
            name: "SeguimientoGeneralRobo",
            component: SeguimientoGeneral,
            meta: { title: "Seguimiento - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRobo",
                "Robo-Seguimiento",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/Robo/Reporte/Citas`,
            name: "citasRobo",
            component: Citas,
            meta: { title: "Citas - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRobo",
                "Robo-ControlCitas",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/Robo/Garantias`,
            name: "GarantiasRobo",
            component: Garantias,
            meta: { title: "Garantías - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRobo",
                "Robo-Garantias",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/Robo/ImpulsosProcesales`,
            name: "ImpulsosProcesales",
            component: ImpulsosProcesales,
            meta: { title: "ImpulsosProcesales - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRobo",
                "Robo-ImpulsosProcesales",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/Robo/Garantias/SolicitarPago`,
            name: "SolicitarPagoRobo",
            component: SolicitarPago,
            meta: { title: "Solicitar Pago - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRobo",
                "Robo-Garantias-SolicitarPago",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/Robo/Garantias/FormatoSolicitud`,
            name: "FormatoSolicitudRobo",
            component: FormatoSolicitud,
            meta: { title: "Formato Solicitud - Prusia+" },
            props: true,
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRobo",
                "Robo-Garantias-FormatoSolicitud",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/Robo/Garantias/PresolicitudPago`,
            name: "PresolicitudPagoRobo",
            component: PresolicitudPago,
            meta: { title: "Presolicitud Pago - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRobo",
                "Robo-Garantias-PresolicitudPago",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/Robo/Garantias/AutorizarPago/`,
            name: "AutorizarPagoRobo",
            component: AutorizarPago,
            meta: { title: "Autorizar Pago - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRobo",
                "Robo-Garantias-AutorizarPago",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/Robo/Contraloria`,
            name: "ContraloriaRobo",
            component: Contralorias,
            meta: { title: "Contraloría - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRobo",
                "Robo-Contraloria",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/Robo/Desconclusion`,
            name: "DesconclusionRobo",
            component: Desconclusion,
            meta: { title: "Desconclusión - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRobo",
                "Robo-Desconclusion",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/Robo/ConcluirConclusion`,
            name: "ConcluirConclusionRobo",
            component: ConcluirConclusion,
            meta: { title: "Conclusión - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRobo",
                "Robo-ConcluirConclusion",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/Robo/MovimientoTramite/:tokenData`,
            name: "MovimientoTramiteRobo",
            component: MovimientoTramite,
            meta: { title: "Movimiento Trámite - Prusia+" },
            props: true,
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRobo",
                "Robo-MovimientoTramite",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/Robo/AutorizarConclusion`,
            name: "AutorizarConclusionRobo",
            component: AutorizarConclusion,
            meta: { title: "Autorizar Conclusión - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRobo",
                "Robo-AutorizarConclusion",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/Robo/AutorizarDesconclusion`,
            name: "AutorizarDesconRobo",
            component: AutorizarCon,
            meta: { title: "Autorizar Desconclusión - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRobo",
                "Robo-AutorizarDesconclusion",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },

          {
            path: `${domain.domainName}/Robo/SolicitarDesconclusion`,
            name: "SolicitarDesconRobo",
            component: SolicitarCon,
            meta: { title: "Solicitar Desconclusión - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRobo",
                "Robo-SolicitarDesconclusion",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/Robo/Honorario`,
            name: "HonorarioRobo",
            component: Honorario,
            meta: { title: "Honorario - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRobo",
                "Robo-Honorario",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          //////////////////////////////////////////////////////////////////////////////////////
          {
            path: `${domain.domainName}/RLV/ReporteDetalle`,
            name: "DetalleRLV",
            component: DetalleRLV,
            meta: { title: "Reporte Detalle - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRLV",
                "RLV-ReporteDetalle",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/RLV/Notas`,
            name: "NotasRLV",
            component: Notas,
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRLV",
                "RLV-Notas",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/RLV/Archivos`,
            name: "ArchivosRLV",
            component: Archivos,
            meta: { title: "Archivos - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRLV",
                "RLV-Archivos",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/RLV/Archivos/AdjuntarCorreo`,
            name: "AdjuntarCorreoRLV",
            component: AdjuntarCorreo,
            meta: { title: "Adjuntar Correo - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRLV",
                "RLV-Archivos-AdjuntarCorreo",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/RLV/Archivos/AdjuntarLlamada`,
            name: "AdjuntarLlamadaRLV",
            component: AdjuntarLlamada,
            meta: { title: "Adjuntar Llamada - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRLV",
                "RLV-Archivos-AdjuntarLlamada",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/RLV/Archivos/AdjuntarVideo`,
            name: "AdjuntarVideoRLV",
            component: AdjuntarVideo,
            meta: { title: "Adjuntar Video - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRLV",
                "RLV-Archivos-AdjuntarVideo",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/RLV/Archivos/ExportarPDF`,
            name: "ExportarPDFRLV",
            component: ExportarPDF,
            meta: { title: "Exportar PDF - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRLV",
                "RLV-Archivos-ExportarPDF",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/RLV/Archivos/CalificarDocs`,
            name: "CalificarDocumentosRLV",
            component: CalificarDocs,
            meta: { title: "Calificar Docs - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRLV",
                "RLV-Archivos-CalificarDocs",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/RLV/Archivos/EnviarCorreo`,
            name: "EnviarCorreoRLV",
            component: EnviarCorreo,
            meta: { title: "Enviar Correo - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRLV",
                "RLV-Archivos-EnviarCorreo",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/RLV/Archivos/DocumentosNoConforme`,
            name: "DocumentosNoConformesRLV",
            component: DocumentoNoConformes,
            meta: { title: "Documentos No Conforme - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRLV",
                "RLV-Archivos-DocumentosNoConforme",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/RLV/Archivos/AdjuntarDocumento`,
            name: "AdjuntarDocumentoRLV",
            component: AdjuntarDocumento,
            meta: { title: "Adjuntar Documento - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRLV",
                "RLV-Archivos-AdjuntarDocumento",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/RLV/Archivos/Reclasificacion`,
            name: "ReclasificacionRLV",
            component: Reclasificacion,
            meta: { title: "Reclasificación - Prusia+" },
            prop: true,
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRLV",
                "RLV-Archivos-Reclasificacion",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/RLV/Archivos/DividirPDF`,
            name: "DividirPDFRLV",
            component: DividirPDF,
            meta: { title: "Dividir PDF - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRLV",
                "RLV-Archivos-DividirPDF",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/RLV/MovimientoGeneral`,
            name: "MovimientoGeneralRLV",
            component: MovimientoGeneral,
            meta: { title: "Movimiento General - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRLV",
                "RLV-MovimientoGeneral",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/RLV/AgregarMovimiento/:tokenData`,
            name: "AgregarMovimientoRLV",
            component: AgregarMovimientoRLV,
            meta: { title: "Agregar Movimientos - Prusia+" },
            props: true,
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRLV",
                "RLV-AgregarMovimiento",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/RLV/AgregarMovimientos/:tokenData`,
            name: "AgregarMovimientosRLV",
            component: AgregarMovimientosRLV,
            meta: { title: "Agregar Movimientos - Prusia+" },
            props: true,
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRLV",
                "RLV-AgregarMovimiento",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/RLV/MovimientoTramite/:tokenData`,
            name: "MovimientoTramiteRLV",
            component: MovimientoTramite,
            meta: { title: "Movimiento Trámite - Prusia+" },
            props: true,
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRLV",
                "RLV-MovimientoTramite",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/RLV/AutorizarConclusion`,
            name: "AutorizarConclusionRLV",
            component: AutorizarConclusion,
            meta: { title: "Autorizar Conclusión - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRLV",
                "RLV-AutorizarConclusion",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/RLV/LiberacionVeh`,
            name: "LiberacionVehRLV",
            component: LiberacionVehRLV,
            meta: { title: "Liberación Veh - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRLV",
                "RLV-LiberacionVehicular",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/RLV/Judicializacion`,
            name: "Judicializacion",
            component: Judicializacion,
            meta: { title: "Judicialización - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRLV",
                "RLV-Judicializacion",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/RLV/EditarMovimiento`,
            name: "EditarMovimientoRLV",
            component: EditarMovimiento,
            meta: { title: "Editar Movimiento - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRLV",
                "RLV-Movimiento-EditarMovimiento",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/RLV/Reasignacion`,
            name: "ReasignacionRLV",
            component: Reasignacion,
            meta: { title: "Reasignación - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRLV",
                "RLV-Reasignacion",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/RLV/ReasignacionLider`,
            name: "ReasignacionLiderRLV",
            component: ReasignacionLider,
            meta: { title: "Reasignación Lider - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRLV",
                "RLV-ReasignacionLider",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/RLV/Seguimiento`,
            name: "SeguimientoGeneralRLV",
            component: SeguimientoGeneral,
            meta: { title: "Seguimiento - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRLV",
                "RLV-Seguimiento",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/RLV/Reporte/Citas`,
            name: "citasRLV",
            component: Citas,
            meta: { title: "Citas - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRLV",
                "RLV-ControlCitas",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/RLV/Garantias`,
            name: "GarantiasRLV",
            component: Garantias,
            meta: { title: "Garantías - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRLV",
                "RLV-Garantias",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/RLV/ImpulsosProcesales`,
            name: "ImpulsosProcesalesRLV",
            component: ImpulsosProcesales,
            meta: { title: "ImpulsosProcesales - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRLV",
                "RLV-ImpulsosProcesales",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/RLV/Garantias/SolicitarPago`,
            name: "SolicitarPagoRLV",
            component: SolicitarPago,
            meta: { title: "Solicitar Pago - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRLV",
                "RLV-Garantias-SolicitarPago",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/RLV/Garantias/FormatoSolicitud`,
            name: "FormatoSolicitudRLV",
            component: FormatoSolicitud,
            meta: { title: "Formato Solicitud - Prusia+" },
            props: true,
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRLV",
                "RLV-Garantias-FormatoSolicitud",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/RLV/Garantias/PresolicitudPago`,
            name: "PresolicitudPagoRLV",
            component: PresolicitudPago,
            meta: { title: "Presolicitud Pago - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRLV",
                "RLV-Garantias-PresolicitudPago",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/RLV/Garantias/AutorizarPago/`,
            name: "AutorizarPagoRLV",
            component: AutorizarPago,
            meta: { title: "Autorizar Pago - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRLV",
                "RLV-Garantias-AutorizarPago",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/RLV/Contraloria`,
            name: "ContraloriaRLV",
            component: Contralorias,
            meta: { title: "Contraloría - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRLV",
                "RLV-Contraloria",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/RLV/Desconclusion`,
            name: "DesconclusionRLV",
            component: Desconclusion,
            meta: { title: "Desconclusión - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRLV",
                "RLV-Desconclusion",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/RLV/ConcluirConclusion`,
            name: "ConcluirConclusionRLV",
            component: ConcluirConclusion,
            meta: { title: "Conclusión - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRLV",
                "RLV-ConcluirConclusion",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/RLV/AutorizarDesconclusion`,
            name: "AutorizarDesconRLV",
            component: AutorizarCon,
            meta: { title: "Autorizar Desconclusión - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRLV",
                "RLV-AutorizarDesconclusion",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/RLV/SolicitarDesconclusion`,
            name: "SolicitarDesconRLV",
            component: SolicitarCon,
            meta: { title: "Solicitar Desconclusión - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRLV",
                "RLV-SolicitarDesconclusion",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/RLV/Honorario`,
            name: "HonorarioRLV",
            component: Honorario,
            meta: { title: "Honorario - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRLV",
                "RLV-Honorario",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          /////////////////////////////////////////////////
          {
            path: `${domain.domainName}/RCMedico/ReporteDetalle`,
            name: "DetalleRCMedico",
            component: DetalleRCMedico,
            meta: { title: "Reporte Detalle - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRCM",
                "RCM-ReporteDetalle",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/RCMedico/Notas`,
            name: "NotasRCM",
            component: Notas,
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRCM",
                "RCM-Notas",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/RCMedico/MovimientoGeneral`,
            name: "MovimientoGeneralRCM",
            component: MovimientoGeneral,
            meta: { title: "Movimiento General - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRCM",
                "RCM-MovimientoGeneral",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/RCMedico/AgregarMovimientos/:tokenData`,
            name: "AgregarMovimientosRCM",
            component: AgregarMovimientosRLV,
            meta: { title: "Agregar Movimientos - Prusia+" },
            props: true,
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRCM",
                "RCM-AgregarMovimiento",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/RCMedico/ProfesionalRCMedico`,
            name: "ProfesionalRCMedico",
            component: RCProfesional,
            meta: { title: "Profesional RCMedico - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRCM",
                "RCM-ProfesionalRCMedico",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/RCMedico/EditarMovimiento`,
            name: "EditarMovimientoRCMedico",
            component: EditarMovimiento,
            meta: { title: "Editar Movimiento - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRCMedico",
                "RCMedico-Movimiento-EditarMovimiento",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/RCMedico/Reasignacion`,
            name: "ReasignacionRCMedico",
            component: Reasignacion,
            meta: { title: "Reasignación - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRCM",
                "RCM-Reasignacion",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/RCMedico/Seguimiento`,
            name: "SeguimientoGeneralRCMedico",
            component: SeguimientoGeneral,
            meta: { title: "Seguimiento - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRCM",
                "RCM-Seguimiento",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/RCMedico/Reporte/Citas`,
            name: "citasRCMedico",
            component: Citas,
            meta: { title: "Citas - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRCM",
                "RCM-ControlCitas",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/RCMedico/Garantias`,
            name: "GarantiasRCMedico",
            component: Garantias,
            meta: { title: "Garantias - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRCM",
                "RCM-Garantias",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/RCMedico/ImpulsosProcesales`,
            name: "ImpulsosProcesalesRCMedico",
            component: ImpulsosProcesales,
            meta: { title: "ImpulsosProcesales - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRCM",
                "RCM-ImpulsosProcesales",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/RCMedico/Garantias/SolicitarPago`,
            name: "SolicitarPagoRCMedico",
            component: SolicitarPago,
            meta: { title: "Solicitar Pago - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRCM",
                "RCM-Garantias-SolicitarPago",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/RCMedico/Garantias/FormatoSolicitud`,
            name: "FormatoSolicitudRCMedico",
            component: FormatoSolicitud,
            meta: { title: "Formato Solicitud - Prusia+" },
            props: true,
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRCM",
                "RCM-Garantias-FormatoSolicitud",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/RCMedico/Garantias/PresolicitudPago`,
            name: "PresolicitudPagoRCMedico",
            component: PresolicitudPago,
            meta: { title: "Presolicitud Pago - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRCM",
                "RCM-Garantias-PresolicitudPago",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/RCMedico/Garantias/AutorizarPago/`,
            name: "AutorizarPagoRCMedico",
            component: AutorizarPago,
            meta: { title: "Autorizar Pago - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRCM",
                "RCM-Garantias-AutorizarPago",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/RCMedico/Contraloria`,
            name: "ContraloriaRCMedico",
            component: Contralorias,
            meta: { title: "Contraloría - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRCM",
                "RCM-Contraloria",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/RCMedico/Desconclusion`,
            name: "DesconclusionRCMedico",
            component: Desconclusion,
            meta: { title: "Desconclusión - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRCM",
                "RCM-Desconclusion",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/RCMedico/Archivos`,
            name: "ArchivosRCMedico",
            component: Archivos,
            meta: { title: "Archivos - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRCM",
                "RCM-Archivos",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/RCMedico/Archivos/AdjuntarLlamada`,
            name: "AdjuntarLlamadaRCM",
            component: AdjuntarLlamada,
            meta: { title: "Adjuntar Llamada - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRCM",
                "RCM-Archivos-AdjuntarLlamada",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },

          {
            path: `${domain.domainName}/RCMedico/Archivos/AdjuntarDocumento`,
            name: "AdjuntarDocumentoRCM",
            component: AdjuntarDocumento,
            meta: { title: "Adjuntar Documento - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRCM",
                "RCM-Archivos-AdjuntarDocumento",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },

          {
            path: `${domain.domainName}/RCMedico/Archivos/AdjuntarVideo`,
            name: "AdjuntarVideoRCM",
            component: AdjuntarVideo,
            meta: { title: "Adjuntar Video - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRCM",
                "RCM-Archivos-AdjuntarVideo",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/RCMedico/Archivos/ExportarPDF`,
            name: "ExportarPDFRCM",
            component: ExportarPDF,
            meta: { title: "Exportar PDF - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRCM",
                "RCM-Archivos-ExportarPDF",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/RCMedico/Archivos/AdjuntarCorreo`,
            name: "AdjuntarCorreoRCM",
            component: AdjuntarCorreo,
            meta: { title: "Adjuntar Correo - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRCM",
                "RCM-Archivos-AdjuntarCorreo",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/RCMedico/Archivos/EnviarCorreo`,
            name: "EnviarCorreoRCM",
            component: EnviarCorreo,
            meta: { title: "Enviar Correo - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRCM",
                "RCM-Archivos-EnviarCorreo",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/RCMedico/Archivos/Reclasificacion`,
            name: "ReclasificacionRCMedico",
            component: Reclasificacion,
            meta: { title: "Reclasificación - Prusia+" },
            prop: true,
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteJur",
                "AJ-Archivos-Reclasificacion",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/RCMedico/Archivos/DividirPDF`,
            name: "DividirPDFRCM",
            component: DividirPDF,
            meta: { title: "Dividir PDF - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRCM",
                "RCM-Archivos-DividirPDF",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/RCMedico/Archivos/CalificarDocs`,
            name: "CalificarDocumentosRCM",
            component: CalificarDocs,
            meta: { title: "Calificar Docs - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRCM",
                "RCM-Archivos-CalificarDocs",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/RCMedico/Archivos/DocumentosNoConforme`,
            name: "DocumentosNoConformesRCM",
            component: DocumentoNoConformes,
            meta: { title: "Documentos No Conforme - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRCM",
                "RCM-Archivos-DocumentosNoConforme",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/RCMedico/ConcluirConclusion`,
            name: "ConcluirConclusionRCM",
            component: ConcluirConclusion,
            meta: { title: "Conclusión - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRCM",
                "RCM-ConcluirConclusion",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/RCMedico/MovimientoTramite/:tokenData`,
            name: "MovimientoTramiteRCMedico",
            component: MovimientoTramite,
            meta: { title: "Movimiento Tramite - Prusia+" },
            props: true,
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRCM",
                "RCM-MovimientoTramite",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/RCMedico/AutorizarConclusion`,
            name: "AutorizarConclusionRCM",
            component: AutorizarConclusion,
            meta: { title: "Autorizar Conclusión - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRCM",
                "RCM-AutorizarConclusion",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/RCMedico/AutorizarDesconclusion`,
            name: "AutorizarDesconRCMedico",
            component: AutorizarCon,
            meta: { title: "Autorizar Desconclusión - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRCM",
                "RCM-AutorizarDesconclusion",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/RCMedico/SolicitarDesconclusion`,
            name: "SolicitarDesconRCMedico",
            component: SolicitarCon,
            meta: { title: "Solicitar Desconclusión - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRCM",
                "RCM-SolicitarDesconclusion",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
          {
            path: `${domain.domainName}/RCMedico/Honorario`,
            name: "HonorarioRCMedico",
            component: Honorario,
            meta: { title: "Honorario - Prusia+" },
            beforeEnter: async (to, from, next) => {
              let datos = await MetodosGenrales.obtenerSessionReporte(
                "reporte"
              );
              verficarPermiso(
                "ExpedienteRCM",
                "RCM-Honorario",
                next,
                permisos.global,
                datos.nrreporte,
                datos.svindice
              );
            },
          },
        ],
      },
      {
        path: `${domain.domainName}/Llamadas`,
        name: "EnlaceLlamada",
        component: EnlaceLlamada,
        meta: { title: "Enlace de llamada - Prusia+" },
        beforeEnter: async (to, from, next) => {
          verficarPermiso(
            to,
            from,
            next,
            permisos.global,
            null,
            null
          );
        },
      },
      {
        path: `${domain.domainName}/PerfilUsuario/`,
        name: "Perfil",
        component: Perfil,
        meta: { title: "Perfil Usuario - Prusia+" },
        beforeEnter: (to, from, next) => {
          verficarPermiso(
            "PerfilUsuario",
            "Perfil-PerfilUsuario",
            next,
            permisos.global
          );
        },
      },
      {
        path: `${domain.domainName}/PerfilUsuario/RestablecerFirma`,
        name: "RestablecerFirma",
        component: RestablecerFirma,
        meta: { title: "Restablecer Firma - Prusia+" },
        beforeEnter: (to, from, next) => {
          verficarPermiso(
            "PerfilUsuario",
            "Perfil-RestablecerFirma",
            next,
            permisos.global
          );
        },
      },
      {
        path: `${domain.domainName}/PerfilUsuario/RestablecerContrasenia`,
        name: "RestablecerContrasenia",
        component: RestablecerContrasenia,
        meta: { title: "Restablecer Contraseña - Prusia+" },
        beforeEnter: (to, from, next) => {
          verficarPermiso(
            "PerfilUsuario",
            "Perfil-RestablecerContrasenia",
            next,
            permisos.global
          );
        },
      },
      {
        path: `${domain.domainName}/Sistemas`,
        name: "Sistemas",
        component: Sistemas,
        meta: { title: "Sistemas - Prusia+" },
        beforeEnter: (to, from, next) => {
          verficarPermiso(
            "Sistemas",
            "Sistemas-Principal",
            next,
            permisos.global
          );
        },
      },
      {
        path: `${domain.domainName}/Sistemas/AdministrarNotificaciones/Busqueda`,
        name: "AdmNotiBusqueda",
        component: AdministrarNotificacionesBusqueda,
        meta: { title: "Busqueda - Prusia+" },
        beforeEnter: (to, from, next) => {
          verficarPermiso(
            "Sistemas",
            "Sistemas-AdministrarNotificaciones-Busqueda",
            next,
            permisos.global
          );
        },
      },
      {
        path: `${domain.domainName}/Sistemas/AdministrarNotificaciones/AltaNotificacion`,
        name: "AltaNotificacion",
        component: AltaNotificacion,
        meta: { title: "Alta Notificacion - Prusia+" },
        beforeEnter: (to, from, next) => {
          verficarPermiso(
            "Sistemas",
            "Sistemas-AdministrarNotificaciones-AltaNotificacion",
            next,
            permisos.global
          );
        },
      },
      {
        path: `${domain.domainName}/Sistemas/AdministrarNotificaciones/DetalleProceso`,
        name: "DetalleProceso",
        component: DetalleProceso,
        meta: { title: "Detalle Proceso - Prusia+" },
        beforeEnter: (to, from, next) => {
          verficarPermiso(
            "Sistemas",
            "Sistemas-AdministrarNotificaciones-DetalleProceso",
            next,
            permisos.global
          );
        },
      },
      {
        path: `${domain.domainName}/Sistemas/Acortador/Busqueda`,
        name: "AcortadorBusqueda",
        component: AcortadorBusqueda,
        meta: { title: "Busqueda - Prusia+" },
        beforeEnter: (to, from, next) => {
          verficarPermiso(
            "Sistemas",
            "Sistemas-Acortador-Busqueda",
            next,
            permisos.global
          );
        },
      },
      {
        path: `${domain.domainName}/Sistemas/Acortador/DetalleAcortador`,
        name: "DetalleAcortador",
        component: DetalleAcortador,
        meta: { title: "Detalle Acortador - Prusia+" },
        beforeEnter: (to, from, next) => {
          verficarPermiso(
            "Sistemas",
            "Sistemas-Acortador-DetalleAcortador",
            next,
            permisos.global
          );
        },
      },
      {
        path: `${domain.domainName}/Sistemas/Acortador/AltaAcortador`,
        name: "AltaAcortador",
        component: AltaAcortador,
        meta: { title: "Alta Acortador - Prusia+" },
        beforeEnter: (to, from, next) => {
          verficarPermiso(
            "Sistemas",
            "Sistemas-Acortador-AltaAcortador",
            next,
            permisos.global
          );
        },
      },
      {
        path: `${domain.domainName}/Sistemas/ReporteAutomatico/listado`,
        name: "Listado",
        component: Listado,
        meta: { title: "Listado - Prusia+" },
        beforeEnter: async (to, from, next) => {
          verficarPermiso(
            "Sistema",
            "Sistema-RA-Listado",
            next,
            permisos.global
          );
        },
      },
      {
        path: `${domain.domainName}/Sistemas/ReporteAutomatico/Reporte`,
        name: "ReporteA",
        component: ReporteA,
        meta: { title: "Reporte - Prusia+" },
        beforeEnter: async (to, from, next) => {
          verficarPermiso(
            "Sistema",
            "Sistema-RA-Reporte",
            next,
            permisos.global
          );
        },
      },
      {
        path: `${domain.domainName}/Sistemas/ReporteAutomatico/Historial`,
        name: "Historial",
        component: Historial,
        meta: { title: "Historial - Prusia+" },
        beforeEnter: async (to, from, next) => {
          verficarPermiso(
            "Sistema",
            "Sistema-RA-Historial",
            next,
            permisos.global
          );
        },
      },
      {
        path: `${domain.domainName}/Sistemas/Utilerias/EnviarSMS`,
        name: "EnviarSMS",
        component: EnviarSms,
        meta: { title: "EnviarSMS - Prusia+" },
        beforeEnter: async (to, from, next) => {
          verficarPermiso(
            "Sistema",
            "Sistema-Utilerias-Enviarsms",
            next,
            permisos.global
          );
        },
      },
      {
        path: `${domain.domainName}/Sistemas/Utilerias/OpenAI`,
        name: "OpenAI",
        component: OpenAI,
        meta: { title: "OpenAI - Prusia+" },
        beforeEnter: async (to, from, next) => {
          verficarPermiso(
            "Sistema",
            "Sistema-Utilerias-OpenAI",
            next,
            permisos.global
          );
        },
      },
      {
        path: `${domain.domainName}/Sistemas/Utilerias/OpenAIVH`,
        name: "OpenAIVH",
        component: OpenAIVH,
        meta: { title: "OpenAIVH - Prusia+" },
        beforeEnter: async (to, from, next) => {
          verficarPermiso(
            "Sistema",
            "Sistema-Utilerias-OpenAIVH",
            next,
            permisos.global
          );
        },
      },
      {
        path: `${domain.domainName}/Sistemas/Utilerias/CambioContacto`,
        name: "CambioContacto",
        component: CambioContacto,
        meta: { title: "CambioContacto - Prusia+" },
        beforeEnter: async (to, from, next) => {
          verficarPermiso(
            "Sistema",
            "Sistema-Utilerias-CambioContacto",
            next,
            permisos.global
          );
        },
      },
      {
        path: `${domain.domainName}/Sistemas/BuscarUsuario`,
        name: "BusquedaUsuarios",
        component: BusquedaUsuarios,
        meta: { title: "Buscar Usuario - Prusia+" },
        beforeEnter: async (to, from, next) => {
          verficarPermiso(
            "Sistema",
            "Sistema-Busqueda-Usuarios",
            next,
            permisos.global
          );
        },
      },
      {
        path: `${domain.domainName}/Sistemas/DetalleUsuario`,
        name: "DetalleUsuario",
        component: DetalleUsuario,
        meta: { title: "Detalle Usuario - Prusia+" },
        beforeEnter: async (to, from, next) => {
          verficarPermiso(
            "Sistema",
            "Sistema-Detalle-Usuario",
            next,
            permisos.global
          );
        },
      },
      {
        path: `${domain.domainName}/Sistemas/Formato`,
        name: "FormatoUsuario",
        component: Formato,
        meta: { title: "Formato - Prusia+" },
        beforeEnter: async (to, from, next) => {
          verficarPermiso(
            "Sistema",
            "Sistema-Formato-Usuario",
            next,
            permisos.global
          );
        },
      },
      {
        path: `${domain.domainName}/Sistemas/AltaUsuarios`,
        name: "AltaUsuario",
        component: AltaUsuario,
        meta: { title: "Alta Usuario - Prusia+" },
        beforeEnter: async (to, from, next) => {
          verficarPermiso(
            "Sistema",
            "Sistema-AltaUsuario",
            next,
            permisos.global
          );
        },
      },
      {
        path: `${domain.domainName}/Sistemas/PreAltas-Autorizadas`,
        name: "PreAltasAutorizadas",
        component: PreAltasAutorizadas,
        meta: { title: "Alta Usuario - Prusia+" },
        beforeEnter: async (to, from, next) => {
          verficarPermiso(
            "Sistema",
            "Sistema-PreAltasAutorizadas",
            next,
            permisos.global
          );
        },
      },
      {
        path: `${domain.domainName}/Pre_Alta`,
        name: "Pre_Alta",
        component: Pre_Alta,
        meta: { title: "Pre Alta - Prusia+" },
        beforeEnter: async (to, from, next) => {
          verficarPermiso("Sistema", "Sistema-Pre-Alta", next, permisos.global);
        },
      },
      {
        path: `${domain.domainName}/Pre_Alta/Pre_AltaDetalle`,
        name: "DetallePreUsuario",
        component: DetallePreUsuario,
        meta: { title: "Pre Alta Detalle - Prusia+" },
        beforeEnter: async (to, from, next) => {
          verficarPermiso(
            "Sistema",
            "Sistema-Pre-Alta-Detalle",
            next,
            permisos.global
          );
        },
      },
      {
        path: `${domain.domainName}/CargaMasivaCivil`,
        name: "CargaMasivaCivil",
        component: CargaMCivil,
        meta: { title: "Carga Masiva Civil - Prusia+" },
        beforeEnter: async (to, from, next) => {
          verficarPermiso(
            "CargaMasivaCivil",
            "CargaMasivaCivil-CargaMasivaCivil",
            next,
            permisos.global
          );
        },
      },
    ],
  },
  // {
  //   path: `${domain.domainName}/Whatsapp_General`,
  //   name: "Whatsapp_General",
  //   component: Whatsapp_General,
  //   meta: { title: "Whatsapp General - Prusia+" },
  //   beforeEnter: async (to, from, next) => {
  //     let datos = await MetodosGenrales.obtenerSessionReporte("reporte");
  //     verficarPermiso(
  //       "Whatsapp",
  //       "Whatsapp-General",
  //       next,
  //       permisos.global,
  //       datos.nrreporte,
  //       datos.svindice
  //     );
  //   },
  // },

  {
    path: `${domain.domainName}/noautorizado`,
    name: "noautorizado",
    component: NotAuthorized,
    meta: { title: "NoAutorizado - Prusia+" },
  },
  {
    path: "*",
    name: "pagenotfound",
    component: PageNotFound,
    meta: { title: "PagenotFound - Prusia+" },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
import Security from "@/utils/security.vue";

router.beforeEach((to, from, next) => {
  if (to.name == "login") {
    next();
    return;
  }

  if (document.cookie.indexOf("SessionTime") === -1) {
    MetodosGenerales.ExpirarCurrentSession(
      domain.domainNameForApi,
      informationPage
    );
  } else {
    MetodosGenerales.RenovateSessionTime();
  }
  if (window.location.href.indexOf("login") == -1) {
    Security.checkSessionExpireRouter(next, Vue, Store, domain);
  } else {
    next();
  }
});

/* Handle Error */
if (window.location.href.indexOf("login") == -1) {
  axios.defaults.baseURL = Store.state.domain.domainNameForApi;
  axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      let errorResponse = error.response;
      if (errorResponse.status === 401) {
        Security.mensajeDeExpirarSesion(Vue, Store);
        return [];
      }
      return Promise.reject(error);
    }
  );
}
